function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#BDEDF8;}\n\t.st1{fill:#66CEEF;}\n\t.st2{fill:#1A87C7;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M239.14,293.3c7.52-1.8,14.21-1.31,19.93,1.31c-0.33-3.76-0.49-7.19-0.65-10.62l-26.63-5.39 c-1.31,0-12.42,0.33-15.36,16.01c-1.14,6.21,1.63,11.11,5.39,14.87C227.54,296.41,238.65,293.47,239.14,293.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M196.82,392.97c-3.92,0-8.66,0.65-12.09,2.94c-3.1,1.96-4.9,4.9-5.88,8.99c-1.14,2.94-6.7,18.14,19.77,31.53 c2.61,1.31,6.7,3.1,11.27,5.23c0.16-15.85,0.65-30.39,1.47-43.62L196.82,392.97z"
}), React.createElement("path", {
  className: "st0",
  d: "M599.23,300.17l75.16,67.97l-174.65-35.29l53.26,200.63c0,0,32.68-62.41,59.47-57.18 c2.94-1.8,6.21-3.59,9.48-5.06c24.02-10.46,43.79-12.42,56.86-5.88c7.84,3.92,13.23,10.78,15.52,19.93 c2.94,12.09-0.98,25.32-10.78,36.11c-14.54,16.17-29.08,67.8-44.11,156.68c3.43,0.98,6.54,1.96,9.97,2.94 c7.19,2.12,14.7,3.76,22.55,4.9c37.41,5.55,65.03,7.03,75.81,3.92l2.45-0.33l77.44,35.78c13.23-6.05,82.34-45.09,98.19-199.98 l-85.12-55.06l0.65-4.08c0.16-0.65,9.97-69.76-101.79-149.66c-82.67-58.98-117.47-91.17-132.99-110.45 c-4.25,2.61-9.31,3.27-13.07,3.27c-2.78,0-4.9-0.33-5.55-0.49l-1.96-0.33l-9.48-9.15c-9.15-11.11-13.4-19.61-15.36-25.98 c-7.52,6.86-11.93,22.06-12.09,43.46C548.58,263.08,598.74,299.84,599.23,300.17z M769.96,511.42l-4.41,11.76 c-98.03-35.94-100.81-133.65-100.97-134.63l12.58-0.33C677.33,391.99,680.27,478.42,769.96,511.42z"
}), React.createElement("path", {
  className: "st0",
  d: "M591.88,196.91c2.29,0.16,4.9-0.33,7.03-1.31c-1.63-2.78-2.78-5.06-3.76-7.19 c-4.08-9.8-11.27-16.5-19.28-18.46c-0.98-0.16-1.8,0-2.61-0.16c1.14,4.25,4.41,11.11,12.74,21.24L591.88,196.91z"
}), React.createElement("path", {
  className: "st0",
  d: "M183.59,317.65c-0.16,0-14.87-4.41-25.65,1.63c-5.23,2.94-8.66,7.68-10.62,14.54 c-2.45,9.15-1.96,16.83,1.8,22.87c6.86,11.11,21.73,14.21,21.89,14.21l27.77,9.48c4.74,0.16,8.17,0.98,8.5,1.14l4.9,1.63 c1.63-23.04,3.59-41.34,5.55-55.06L183.59,317.65z"
}), React.createElement("path", {
  className: "st1",
  d: "M562.47,558.8c0.33-1.96,9.8-58,49.83-82.51c-26.79-5.23-59.47,57.18-59.47,57.18l-53.26-200.63l-30.06-6.05 l78.1,283.63L562.47,558.8z"
}), React.createElement("path", {
  className: "st2",
  d: "M497.28,324.02l0.49,1.96l155.21,31.37l-57.51-52.12c0,0-53.43-38.23-52.77-88.23 c0.33-27.12,6.86-43.62,17.16-50.32c-0.16-4.08,0.82-6.7,1.47-8.01c-2.45,0.98-4.74,2.12-6.86,3.76 c-11.44,8.99-17.65,27.77-17.97,54.41c-0.65,52.61,53.1,91.82,54.9,92.96l40.52,36.76l-166-33.33l0.98,3.27L497.28,324.02z"
}), React.createElement("path", {
  className: "st2",
  d: "M209.89,448.52c-5.88-2.61-10.95-4.9-14.05-6.54c-33.33-16.83-23.2-38.56-23.2-38.56 c3.27-15.03,16.83-16.99,25.49-16.66l-28.26-9.64c0,0-39.05-7.52-28.76-44.93c8.66-31.37,44.11-20.59,44.11-20.59l33.33,10.29 c0,0,0,0,0-0.16l0.33-2.45c0.16-1.31,0.49-2.12,0.82-3.27c-6.21-5.06-11.6-12.42-9.64-22.55c4.25-22.38,22.87-20.91,22.87-20.91 l25,5.06c-0.16-2.29-0.33-4.41-0.33-6.37l-24.02-4.9c-8.33-0.65-25.32,4.08-29.57,26.14c-1.47,7.52,0.33,14.05,3.59,19.44 l-20.42-6.21c-0.82-0.33-19.77-5.88-35.29,2.61c-8.33,4.57-13.89,12.09-16.66,22.38c-3.43,12.58-2.45,23.69,3.27,33 c9.64,15.68,29.08,19.61,29.41,19.61l8.66,2.94c-5.23,3.76-8.66,9.15-9.64,14.7c-0.16,0.33-12.25,27.45,25.98,46.73 c3.59,1.8,9.48,4.41,16.83,7.68C209.89,453.25,209.73,450.8,209.89,448.52z"
}), React.createElement("path", {
  className: "st2",
  d: "M854.1,464.04c0.98-17.32-3.1-83.32-107.34-157.66c-84.79-60.45-130.7-100.64-140.02-122.86 c-5.72-13.56-16.01-23.04-28.1-25.81c-6.21-1.47-12.09-0.98-17.32,0.98l5.39,3.1l3.1,1.47c2.29-0.16,4.74,0.16,7.35,0.65 c10.78,2.61,19.12,11.44,23.69,22.22c8.01,19.12,40.68,53.26,142.14,125.48c116.98,83.49,104.4,155.87,104.4,155.87l84.79,54.9 c-17.15,180.86-104.89,209.94-104.89,209.94l-77.77-35.94c-16.17,4.74-57.51-0.49-78.59-3.59c-7.84-1.14-15.68-2.94-23.36-5.06 c-3.27-0.98-6.21-1.8-9.31-2.78c-0.33,2.12-0.65,4.08-0.98,6.21c2.94,0.82,5.72,1.8,8.66,2.61c7.68,2.29,15.85,3.92,24.18,5.23 c26.79,4.08,61.59,7.84,78.75,4.08l77.93,36.11l2.29-0.82c3.76-1.31,91.82-32.68,109.14-215.5l0.33-3.76L854.1,464.04z"
}), React.createElement("path", {
  className: "st2",
  d: "M211.85,389.86c0.16-2.12,0.33-4.41,0.33-6.54l-4.9-1.63c-0.33,0-3.76-0.82-8.5-1.14l-27.77-9.48 c-0.16,0-15.19-3.1-21.89-14.21c-3.76-6.05-4.41-13.89-1.8-22.87c1.96-7.03,5.39-11.76,10.62-14.54 c10.78-5.88,25.49-1.63,25.65-1.63l34.15,10.46c0.33-2.12,0.65-4.41,0.82-6.37l-33.33-10.29c0,0-35.45-10.78-44.11,20.59 c-10.46,37.41,28.76,44.93,28.76,44.93l28.26,9.64c4.41,0.16,7.68,0.98,7.68,0.98L211.85,389.86z"
}), React.createElement("path", {
  className: "st2",
  d: "M216.43,294.77c2.94-15.68,14.05-16.01,15.36-16.01l26.63,5.39c-0.16-2.29-0.33-4.41-0.33-6.54l-25-5.06 c0,0-18.63-1.31-22.87,20.91c-1.96,10.13,3.43,17.48,9.64,22.55c0.49-2.45,1.14-4.57,1.96-6.54 C217.9,305.88,215.29,300.82,216.43,294.77z"
}), React.createElement("path", {
  className: "st2",
  d: "M211.85,389.86l-5.88-2.12c0,0-3.27-0.65-7.68-0.98l13.56,4.74C211.85,391.01,211.85,390.35,211.85,389.86z"
}), React.createElement("path", {
  className: "st2",
  d: "M674.39,368.13l-75.16-67.97c-0.49-0.33-50.65-37.09-50.16-83.16c0.33-21.4,4.57-36.6,12.09-43.46 c-0.82-2.61-1.31-5.06-1.31-6.86c-10.29,6.7-16.83,23.2-17.16,50.32c-0.65,49.99,52.77,88.23,52.77,88.23l57.51,52.12 l-155.21-31.37l1.8,6.86L674.39,368.13z"
}), React.createElement("path", {
  className: "st2",
  d: "M198.62,436.43c-26.63-13.4-20.91-28.59-19.77-31.53c0.82-4.08,2.78-7.03,5.88-8.99 c3.43-2.29,8.17-2.78,12.09-2.94l14.54,5.06c0.16-2.29,0.33-4.41,0.33-6.54l-13.56-4.74c-8.82-0.33-22.38,1.63-25.49,16.66 c0,0-10.13,21.73,23.2,38.56c3.1,1.47,8.17,3.92,14.05,6.54c0-2.45,0.16-4.57,0.16-6.86C205.16,439.53,201.23,437.73,198.62,436.43 z"
}), React.createElement("path", {
  className: "st2",
  d: "M573.25,169.79c0.98,0.16,1.63-0.16,2.61,0.16c8.17,1.96,15.19,8.66,19.28,18.46 c0.82,2.12,2.12,4.41,3.76,7.19c0.65-0.33,1.63-0.49,1.96-0.98l9.8,8.01c-1.31,1.47-2.61,2.78-4.25,3.59 c15.52,19.28,50.32,51.46,132.99,110.45C851.16,396.4,841.36,465.51,841.2,466.32l-0.65,4.08l85.12,55.06 c-15.85,154.89-84.96,193.93-98.19,199.98l-77.28-35.94l-2.29,0.65c-10.78,3.1-38.39,1.8-75.81-3.92 c-7.84-1.14-15.36-2.78-22.55-4.9c-3.43-0.98-6.54-1.96-9.97-2.94c-0.33,2.12-0.65,4.08-0.98,6.21c3.1,0.98,6.05,1.8,9.31,2.78 c7.68,2.12,15.52,3.92,23.36,5.06c21.08,3.1,62.41,8.5,78.59,3.59l77.77,35.94c0,0,87.74-29.25,104.89-209.94l-84.79-54.9 c0,0,12.74-72.38-104.4-155.87C641.87,238.9,609.2,204.75,601.19,185.8c-4.57-10.78-12.91-19.61-23.69-22.22 c-2.61-0.65-5.06-0.82-7.35-0.65l2.61,1.14C572.6,164.4,572.11,166.19,573.25,169.79z"
}), React.createElement("polygon", {
  className: "st2",
  points: "497.93,325.98 497.28,324.02 466.89,316.5 467.87,319.94  "
}), React.createElement("polygon", {
  className: "st2",
  points: "469.67,326.8 499.73,332.84 497.93,325.98 467.87,319.94  "
}), React.createElement("path", {
  className: "st2",
  d: "M260.54,255.07c-0.16,0-0.65-0.33-0.65-0.49l0.65-0.82c0-0.16,0-0.49,0-0.65c0-14.38,3.59-25.16,10.46-32.02 c7.52-7.35,16.17-7.19,16.5-7.19c9.64-2.12,16.99,1.8,22.38,7.35l-2.45-17.32c0,0-0.16-0.98-0.49-2.12 c-1.47-1.31-2.45-2.29-2.61-2.45l1.96-1.96c-0.65-6.54-0.65-16.99,5.06-25.81c5.23-8.01,13.89-13.07,25.98-14.87 c25.16-3.59,35.62,15.68,39.54,26.63l2.29,0.65c-0.33,0.98-0.82,1.8-1.14,2.78c0.65,2.12,0.98,3.76,0.98,3.76l5.88,34.64 c1.8-9.64,7.03-18.79,18.46-21.57c24.18-5.72,32.35,13.72,32.51,13.89l0.98,3.76l2.61-0.65c0.16,0.49,0.98,4.57-0.33,9.31 l22.71,82.51l3.92,0.82l-26.63-96.88c-3.27-7.84-15.03-21.08-36.6-16.01c-7.68,1.8-12.91,6.05-16.34,11.44l-3.59-21.57 c-2.61-14.7-15.19-41.34-45.75-36.92c-13.07,1.96-22.71,7.52-28.43,16.5c-9.97,15.36-4.57,34.8-4.41,34.8l1.31,9.64 c0,0-0.16,0-0.16-0.16c-5.55-3.76-12.09-5.06-17.48-3.76c-1.31,0-10.78,0-19.12,8.33c-7.68,7.52-11.6,19.12-11.6,34.47 c0,3.92,0.33,10.13,0.65,17.97l3.59,0.82C260.87,264.71,260.71,259.16,260.54,255.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M632.72,697.35c-20.59,129.23-82.02,155.21-93.62,159.13L528,955.49l-1.63,0.49 c-51.63,17.32-93.78,23.36-127.44,23.36c-77.93,0-110.94-32.51-112.9-34.47l-0.65-0.82l-2.78-85.12 c-11.76-13.56-25.16-51.3-32.35-72.87c-2.61-7.84-4.57-15.85-6.05-23.53c-24.18-126.78-30.88-229.39-30.72-305.69 c-1.14-0.49-2.45-1.14-3.59-1.63c-0.16,76.63,6.54,180.05,30.88,307.81c1.47,8.01,3.59,16.01,6.21,24.02 c8.5,25.98,20.91,59.14,32.19,73.19l2.78,85.28l1.63,1.8c1.96,1.96,35.94,35.45,115.67,35.45c34.15,0,76.63-6.21,128.42-23.53 l3.76-1.31l11.11-99.01c16.34-6.37,74.01-37.09,93.78-161.26c0.33-2.45,0.82-4.57,1.14-7.03c-1.14-0.33-2.29-0.65-3.43-0.98 C633.54,692.44,633.05,694.73,632.72,697.35z"
}), React.createElement("path", {
  className: "st2",
  d: "M337.82,159.5c22.06-3.27,31.86,12.58,35.94,23.04l3.27,0.98c-3.92-10.95-14.38-30.23-39.54-26.63 c-12.09,1.8-20.91,6.7-26.14,14.87c-5.72,8.82-5.88,19.12-5.06,25.81l2.61-2.61C308.09,183.19,310.86,163.42,337.82,159.5z"
}), React.createElement("path", {
  className: "st2",
  d: "M387.49,243.15c-1.14-0.65-1.8-1.31-2.61-2.12l9.8,57.84l1.8,0.33L387.49,243.15z"
}), React.createElement("path", {
  className: "st2",
  d: "M263.32,256.87c-1.47-0.98-2.29-1.47-2.78-1.8c0,4.08,0.33,9.64,0.65,16.83l2.78,0.49 C263.65,266.02,263.48,260.79,263.32,256.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M287.5,216.68c16.99-3.59,24.67,15.03,27.28,24.51l0.49,0.16l-5.06-36.76c-1.31-0.98-2.45-1.8-3.27-2.61 c0.33,1.14,0.49,2.12,0.49,2.12l2.45,17.32c-5.23-5.72-12.58-9.48-22.38-7.35c-0.33,0-8.99-0.16-16.5,7.19 c-7.03,6.86-10.46,17.65-10.46,32.02c0,0.16,0,0.49,0,0.65l2.94-3.92C265.12,216.68,287.5,216.68,287.5,216.68z"
}), React.createElement("path", {
  className: "st2",
  d: "M459.05,311.77l2.94,0.65l-22.71-82.51c-0.33,1.31-0.98,2.61-1.63,3.92L459.05,311.77z"
}), React.createElement("path", {
  className: "st2",
  d: "M630.11,697.02c-22.22,139.85-93.45,157.5-93.45,157.5l-11.11,99.01c-171.22,57.35-237.56-10.46-237.56-10.46 l-2.78-84.96c-11.6-12.74-25.65-52.28-32.35-72.7c-2.45-7.68-4.57-15.36-6.05-23.2c-24.34-127.76-30.88-229.88-30.88-304.05 c-0.98-0.33-1.8-0.82-2.61-1.14c-0.16,76.3,6.7,178.9,30.72,305.69c1.47,7.84,3.59,15.68,6.05,23.53 c7.03,21.57,20.59,59.31,32.35,72.87l2.78,85.12l0.65,0.82c1.96,1.96,34.96,34.47,112.9,34.47c33.66,0,75.81-6.05,127.44-23.36 l1.63-0.49l11.11-99.01c11.6-3.92,73.03-29.9,93.62-159.13c0.49-2.61,0.82-4.9,1.31-7.52c-0.82-0.33-1.8-0.49-2.61-0.82 C630.93,691.79,630.44,694.24,630.11,697.02z"
}), React.createElement("path", {
  className: "st2",
  d: "M384.06,236.28l2.78-1.96c0-9.64,2.45-24.51,17.15-27.94c22.06-5.23,29.41,12.25,29.41,12.25l0.98,3.27 l2.61-0.65l-0.98-3.76c0-0.16-8.33-19.61-32.51-13.89c-11.6,2.78-16.66,12.09-18.46,21.57l-5.88-34.64c0,0-0.33-1.63-0.98-3.76 c-0.49,1.47-1.14,2.78-1.63,4.25L384.06,236.28z"
}), React.createElement("path", {
  className: "st2",
  d: "M221.33,329.25l-3.43-1.14c-1.96,13.72-3.92,32.02-5.55,55.06l3.59,1.31 C217.41,361.43,219.37,343.14,221.33,329.25z"
}), React.createElement("path", {
  className: "st2",
  d: "M694.32,485.6c-2.29-9.15-7.52-16.01-15.52-19.93c-13.23-6.54-32.84-4.57-56.86,5.88 c-3.43,1.47-6.54,3.1-9.48,5.06c1.63,0.33,3.27,0.98,4.9,1.8c1.96-1.14,3.76-2.61,6.05-3.59c23.04-9.97,41.66-11.93,53.92-5.88 c5.88,2.94,9.64,8.01,12.09,14.38c0.33,0,0.65,0,0.82,0l-0.16,1.14c0.16,0.65,0.82,1.31,0.98,1.96c2.61,10.95-0.98,23.04-9.8,32.84 c-15.03,16.66-29.74,68.78-44.77,157.99c1.14,0.33,2.29,0.65,3.43,0.98c15.03-88.88,29.41-140.51,44.11-156.68 C693.34,510.93,697.26,497.69,694.32,485.6z"
}), React.createElement("path", {
  className: "st2",
  d: "M239.96,296.9c7.52-1.8,14.05-1.14,19.44,2.12c1.47,0.82,2.61,1.96,3.76,2.94 c-0.49-6.21-0.82-11.76-1.14-17.15l-3.59-0.82c0.16,3.43,0.49,6.86,0.65,10.62c-5.72-2.78-12.42-3.1-19.93-1.31 c-0.49,0.16-11.6,3.1-17.32,16.34c0.98,0.82,1.96,1.63,2.94,2.29C229.5,299.68,239.47,296.9,239.96,296.9z"
}), React.createElement("path", {
  className: "st2",
  d: "M211.36,398.03c-0.65,13.23-1.14,27.77-1.47,43.62c1.14,0.49,2.45,0.98,3.59,1.63 c0.16-15.85,0.65-30.72,1.31-43.95L211.36,398.03z"
}), React.createElement("polygon", {
  className: "st2",
  points: "408.4,373.36 398.6,312.42 396.96,312.09 407.26,372.87  "
}), React.createElement("path", {
  className: "st2",
  d: "M214.96,399.34c-0.65,13.4-1.14,28.1-1.31,43.95c0.82,0.33,1.63,0.65,2.61,1.14 c0.16-16.34,0.65-31.04,1.31-44.28L214.96,399.34z"
}), React.createElement("path", {
  className: "st2",
  d: "M218.39,385.45c1.47-21.73,3.27-38.39,4.74-49.5c-0.33-0.16-0.82-0.49-0.98-0.49l1.31-2.29 c0.16-1.14,0.33-1.96,0.49-2.94l-2.61-0.82c-1.96,13.72-3.92,32.19-5.55,55.22L218.39,385.45z"
}), React.createElement("polygon", {
  className: "st2",
  points: "427.68,493.61 424.09,470.9 423.92,470.9  "
}), React.createElement("path", {
  className: "st2",
  d: "M690.72,486.42c-0.16-0.82-0.65-1.31-0.98-1.96l-0.82,5.06l-0.33,3.27c0.33,8.99-3.43,17.81-9.8,24.67 c-12.74,14.05-27.77,53.43-45.58,159.13c0.82,0.33,1.8,0.49,2.61,0.82c15.03-89.21,29.74-141.49,44.77-157.99 C689.91,509.29,693.5,497.37,690.72,486.42z"
}), React.createElement("polygon", {
  className: "st2",
  points: "421.47,456.36 421.8,456.52 410.69,387.58 409.71,387.25  "
}), React.createElement("path", {
  className: "st2",
  d: "M240.61,299.51c21.73-5.23,26.14,13.72,26.14,13.72v0.33c-0.82-10.46-1.31-19.61-1.96-28.1l-2.78-0.49 c0.33,5.39,0.65,10.95,1.14,17.15c-1.14-0.98-2.29-2.12-3.76-2.94c-5.39-3.27-11.93-3.92-19.44-2.12 c-0.49,0.16-10.46,2.78-15.19,15.03c0.82,0.65,1.8,1.31,2.61,1.8C231.62,302.29,240.61,299.51,240.61,299.51z"
}), React.createElement("path", {
  className: "st2",
  d: "M619.65,479.56c1.63-0.82,3.1-1.63,4.74-2.45c34.31-14.7,55.55-10.62,62.25,6.05c1.14-0.16,1.96-0.16,2.61,0 c-2.29-6.37-6.21-11.44-12.09-14.38c-12.09-6.05-30.72-4.08-53.92,5.88c-2.12,0.98-3.92,2.45-6.05,3.59 c0.65,0.33,1.47,0.49,2.12,0.98C619.65,479.4,619.65,479.56,619.65,479.56z"
}), React.createElement("path", {
  className: "st2",
  d: "M547.77,623.82l18.3-64.05c0.33-2.29,10.46-58.98,51.3-81.69c-1.63-0.82-3.27-1.47-4.9-1.8 c-40.03,24.51-49.67,80.55-49.83,82.51l-14.7,51.63l-78.1-283.63l-3.92-0.82L547.77,623.82z"
}), React.createElement("path", {
  className: "st2",
  d: "M566.06,559.94l-18.3,64.05l-82.02-297.84l-2.94-0.82l84.96,308.46l20.91-73.19c0,0,9.8-59.14,51.14-81.04 c-0.16,0-0.16-0.16-0.16-0.33c-0.65-0.49-1.47-0.65-2.12-0.98C576.52,500.96,566.39,557.65,566.06,559.94z"
}), React.createElement("path", {
  className: "st2",
  d: "M261.69,278.27c-0.16-2.12-0.33-4.41-0.33-6.37l-3.59-0.82c0.16,1.96,0.16,4.25,0.33,6.37L261.69,278.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M222.31,322.39l0.33-2.45c0-0.49,0.16-0.98,0.33-1.47c-1.14-0.65-2.12-1.47-3.1-2.45 c-0.33,1.14-0.65,2.12-0.82,3.27l-0.33,2.45c0,0,0,0,0,0.16l3.43,1.14C222.15,322.71,222.31,322.55,222.31,322.39z"
}), React.createElement("path", {
  className: "st2",
  d: "M635.01,683.62c-0.33,2.12-0.65,4.08-0.98,6.21c1.14,0.33,2.29,0.65,3.43,0.98c0.33-2.12,0.65-4.08,0.98-6.21 C637.3,684.28,636.15,683.95,635.01,683.62z"
}), React.createElement("polygon", {
  className: "st2",
  points: "462.81,315.52 466.89,316.5 465.91,313.24 461.99,312.42  "
}), React.createElement("path", {
  className: "st2",
  d: "M213.49,450.15c-1.31-0.49-2.45-1.14-3.59-1.63c0,2.29,0,4.74,0,6.86c1.14,0.49,2.45,0.98,3.59,1.63 C213.49,454.72,213.49,452.27,213.49,450.15z"
}), React.createElement("path", {
  className: "st2",
  d: "M631.42,689.01c0.82,0.33,1.8,0.49,2.61,0.82c0.33-2.12,0.65-4.08,0.98-6.21c-0.82-0.33-1.8-0.49-2.61-0.82 C632.07,684.93,631.74,686.89,631.42,689.01z"
}), React.createElement("polygon", {
  className: "st2",
  points: "409.55,380.71 409.55,380.22 408.4,379.9 408.56,380.39  "
}), React.createElement("path", {
  className: "st2",
  d: "M263.97,272.39l-2.78-0.49c0.16,1.96,0.33,4.25,0.33,6.37l2.78,0.49C264.3,276.64,264.14,274.52,263.97,272.39 z"
}), React.createElement("path", {
  className: "st2",
  d: "M225.25,320.26c0-0.16,0-0.16,0.16-0.33c-0.82-0.49-1.63-0.98-2.45-1.47c-0.16,0.49-0.33,0.98-0.33,1.47 l-0.33,2.45c0,0.16,0,0.49-0.16,0.65l2.61,0.82C224.92,322.39,225.25,321.08,225.25,320.26z"
}), React.createElement("path", {
  className: "st2",
  d: "M216.1,451.29c-0.98-0.49-1.63-0.82-2.61-1.14c0,2.29,0,4.57,0,6.86c0.82,0.33,1.63,0.82,2.61,1.14 C216.1,455.87,215.94,453.42,216.1,451.29z"
}), React.createElement("polygon", {
  className: "st2",
  points: "459.87,314.87 462.81,315.52 461.99,312.42 459.05,311.77  "
}), React.createElement("polygon", {
  className: "st2",
  points: "397.62,305.72 396.47,299.19 394.68,298.86 395.82,305.39  "
}), React.createElement("path", {
  className: "st2",
  d: "M215.45,391.01l-3.59-1.31c0,0.49,0,1.14-0.16,1.63l3.59,1.14C215.29,392.15,215.45,391.66,215.45,391.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M224.76,311.93c-0.98-0.82-1.96-1.47-2.94-2.29c-0.82,1.96-1.47,4.08-1.96,6.54c0.98,0.82,2.12,1.63,3.1,2.45 C223.45,316.01,223.94,313.89,224.76,311.93z"
}), React.createElement("path", {
  className: "st2",
  d: "M221.33,329.25c0.33-2.12,0.65-4.41,0.82-6.37l-3.43-1.14c-0.33,1.96-0.65,4.25-0.82,6.37L221.33,329.25z"
}), React.createElement("path", {
  className: "st2",
  d: "M215.29,392.8l-3.59-1.14c-0.16,2.12-0.33,4.25-0.33,6.54l3.59,1.14C214.96,397.05,215.12,394.93,215.29,392.8 z"
}), React.createElement("path", {
  className: "st2",
  d: "M215.78,384.63l-3.59-1.31c-0.16,2.12-0.33,4.41-0.33,6.54l3.59,1.31 C215.61,388.88,215.61,386.6,215.78,384.63z"
}), React.createElement("path", {
  className: "st2",
  d: "M213.49,443.29c-1.14-0.49-2.45-1.14-3.59-1.63c0,2.29-0.16,4.41-0.16,6.86c1.14,0.49,2.29,0.98,3.59,1.63 C213.49,447.7,213.49,445.58,213.49,443.29z"
}), React.createElement("path", {
  className: "st2",
  d: "M635.99,677.25c-0.33,2.12-0.65,4.08-0.98,6.21c1.14,0.33,2.29,0.65,3.43,0.98c0.33-2.12,0.65-4.25,0.98-6.21 C638.44,678.07,637.3,677.74,635.99,677.25z"
}), React.createElement("path", {
  className: "st2",
  d: "M262.01,284.81c-0.16-2.29-0.33-4.41-0.33-6.54l-3.59-0.82c0.16,2.12,0.33,4.25,0.33,6.54L262.01,284.81z"
}), React.createElement("polygon", {
  className: "st2",
  points: "409.55,380.22 408.4,373.36 407.26,372.87 408.4,379.9  "
}), React.createElement("path", {
  className: "st2",
  d: "M633.38,676.6c-0.33,1.96-0.65,4.25-0.98,6.21c0.82,0.33,1.8,0.49,2.61,0.82c0.33-2.12,0.65-4.25,0.98-6.21 C635.17,677.09,634.36,676.76,633.38,676.6z"
}), React.createElement("path", {
  className: "st2",
  d: "M215.29,392.8c-0.16,2.12-0.33,4.25-0.33,6.54l2.45,0.82c0.16-2.29,0.16-4.41,0.33-6.54L215.29,392.8z"
}), React.createElement("path", {
  className: "st2",
  d: "M217.9,391.99l-2.45-0.82c0,0.49,0,1.14-0.16,1.63l2.45,0.82C217.9,392.97,217.9,392.48,217.9,391.99z"
}), React.createElement("path", {
  className: "st2",
  d: "M224.76,323.69l-2.61-0.82c-0.33,1.96-0.65,4.25-0.82,6.37l2.61,0.82 C224.27,327.61,224.6,325.49,224.76,323.69z"
}), React.createElement("path", {
  className: "st2",
  d: "M227.38,313.73c-0.98-0.49-1.8-1.14-2.61-1.8c-0.82,1.96-1.31,4.08-1.8,6.54c0.82,0.49,1.63,0.98,2.45,1.47 C225.74,317.48,226.56,315.69,227.38,313.73z"
}), React.createElement("path", {
  className: "st2",
  d: "M216.1,444.43c-0.82-0.33-1.63-0.82-2.61-1.14c0,2.29,0,4.57-0.16,6.86c0.98,0.33,1.63,0.65,2.61,1.14 C216.1,449.01,216.1,446.56,216.1,444.43z"
}), React.createElement("polygon", {
  className: "st2",
  points: "422.62,463.55 422.94,463.55 421.8,456.52 421.47,456.36  "
}), React.createElement("polygon", {
  className: "st2",
  points: "398.6,312.42 397.62,305.72 395.82,305.39 396.96,312.09  "
}), React.createElement("polygon", {
  className: "st2",
  points: "422.94,463.55 422.62,463.55 422.62,463.71 422.94,463.87  "
}), React.createElement("path", {
  className: "st2",
  d: "M264.79,285.46c-0.16-2.29-0.33-4.41-0.33-6.54l-2.78-0.49c0.16,2.12,0.16,4.25,0.33,6.54L264.79,285.46z"
}), React.createElement("polygon", {
  className: "st2",
  points: "422.62,463.71 423.92,470.9 424.09,470.9 422.94,463.87  "
}), React.createElement("polygon", {
  className: "st2",
  points: "410.69,387.58 409.55,380.71 408.56,380.39 409.71,387.25  "
}), React.createElement("path", {
  className: "st2",
  d: "M218.39,385.45l-2.61-0.82c-0.16,2.12-0.33,4.41-0.33,6.54l2.45,0.82 C218.06,389.7,218.23,387.58,218.39,385.45z"
}), React.createElement("polygon", {
  className: "st2",
  points: "467.87,319.94 466.89,316.5 462.81,315.52 463.79,319.12  "
}), React.createElement("polygon", {
  className: "st2",
  points: "460.85,318.63 463.79,319.12 462.81,315.52 459.87,314.87  "
}), React.createElement("polygon", {
  className: "st2",
  points: "469.67,326.8 467.87,319.94 463.79,319.12 465.75,325.98  "
}), React.createElement("polygon", {
  className: "st2",
  points: "465.75,325.98 463.79,319.12 460.85,318.63 462.81,325.33  "
}), React.createElement("path", {
  className: "st2",
  d: "M403.17,300.49l-8.82-54.57c-1.63-0.49-2.61-0.98-3.92-1.63l8.82,55.39L403.17,300.49z"
}), React.createElement("path", {
  className: "st2",
  d: "M452.19,310.46l3.92,0.82l-20.42-74.5c-0.82,0.98-1.96,1.8-2.94,2.78L452.19,310.46z"
}), React.createElement("path", {
  className: "st2",
  d: "M393.37,231.87c0.49-7.52,2.78-16.99,12.25-19.28c16.01-3.76,21.57,7.35,21.89,7.84l0.82,3.27l3.43-0.98 l-0.98-3.27c-0.16-0.33-6.54-15.03-26.14-10.29c-12.09,2.94-14.87,14.87-15.19,23.53l2.61-1.8 C392.23,230.89,392.55,231.22,393.37,231.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M311.19,257.2l3.59,25.49l3.76,0.82l-4.25-30.55C313.31,254.42,312.33,256.05,311.19,257.2z"
}), React.createElement("path", {
  className: "st2",
  d: "M388.14,297.55l3.76,0.82l-17.32-102.11c-0.82,1.8-1.96,3.1-2.94,4.74L388.14,297.55z"
}), React.createElement("path", {
  className: "st2",
  d: "M322.3,245.43c0-0.16-0.16-0.65-0.16-1.14l-4.9-34.96c-1.47-0.98-2.78-1.8-3.92-2.61l3.43,25.16 c1.31,2.94,2.29,5.72,2.78,8.01l5.88,44.93l2.29,0.49L322.3,245.43z"
}), React.createElement("path", {
  className: "st2",
  d: "M270.02,246.09c2.45-22.06,15.85-23.04,18.79-23.2c3.59-0.82,6.37-0.16,9.15,1.63 c4.41,3.1,7.52,8.99,9.31,14.38l5.23,1.63l-0.98-6.86c-3.43-7.19-10.46-16.83-23.53-14.21c-0.82,0-7.52,0-13.4,5.88 c-4.41,4.41-6.7,11.6-7.68,20.1l0.49-0.65C268.06,244.94,269.2,245.6,270.02,246.09z"
}), React.createElement("path", {
  className: "st2",
  d: "M269.69,260.46c-1.47-0.65-2.45-1.31-3.59-2.12c0.16,3.92,0.33,8.66,0.65,14.54l3.59,0.82 C270.02,268.63,269.85,264.06,269.69,260.46z"
}), React.createElement("path", {
  className: "st2",
  d: "M623.74,696.04c-21.24,133.32-88.06,152.11-88.72,152.43l-4.25,0.98l-11.11,99.34 c-147.53,48.2-214.19,0.82-225.47-8.66l-2.78-84.63l-1.63-1.8c-7.84-8.5-19.12-34.15-31.04-70.42c-2.45-7.52-4.41-15.03-5.88-22.55 C232.44,653.4,224.6,563.7,222.64,492.63c-1.63-5.88-0.82-10.13-0.82-10.46c0.16-0.49,0.33-0.98,0.49-1.47 c-0.16-6.86-0.16-13.4-0.16-19.93c-1.14-0.49-2.45-1.14-3.59-1.47c0,75.65,6.86,177.1,30.72,302.25 c1.47,7.52,3.43,15.19,5.88,22.87c5.72,17.32,20.26,59.14,31.86,71.72l0.65,0.82v0.98l2.78,83.98c3.59,3.27,20.26,17.15,53.1,25.49 c33.98,8.66,92.64,12.91,179.39-15.85l11.11-99.17l1.8-0.49c0.65-0.16,69.76-19.12,91.33-155.21c0.49-2.94,0.98-5.39,1.31-8.33 c-1.14-0.33-2.29-0.65-3.59-0.98C624.72,690.16,624.23,692.93,623.74,696.04z"
}), React.createElement("path", {
  className: "st2",
  d: "M315.11,192.34c0-4.9,0.65-10.78,3.92-15.68c3.76-5.72,10.46-9.48,19.77-10.78 c16.01-2.61,24.02,7.35,28.1,15.85c0.16-0.33,0.33-0.65,0.33-1.14l3.43,0.98c-4.08-9.64-13.23-22.22-32.35-19.44 c-10.46,1.47-17.81,5.72-22.22,12.42c-3.59,5.55-4.57,12.25-4.41,17.65l1.63-1.8C313.64,191.03,314.29,191.68,315.11,192.34z"
}), React.createElement("path", {
  className: "st2",
  d: "M404.64,209c19.61-4.57,25.98,10.13,26.14,10.29l0.98,3.27l0.65-0.16l0.98-0.33l0,0l0.98-0.16l-0.98-3.27 c0,0-7.19-17.48-29.41-12.25c-14.7,3.43-17.15,18.3-17.15,27.94l2.61-1.8C389.78,223.87,392.55,211.94,404.64,209z"
}), React.createElement("path", {
  className: "st2",
  d: "M315.93,174.53c4.41-6.7,11.76-10.95,22.22-12.42c19.12-2.78,28.26,9.8,32.35,19.44l3.1,0.98 c-4.08-10.46-13.89-26.3-35.94-23.04c-26.79,3.92-29.57,23.53-28.92,35.29l2.61-2.61C311.35,186.78,312.33,180.24,315.93,174.53z"
}), React.createElement("path", {
  className: "st2",
  d: "M391.9,298.21l2.78,0.65l-9.8-57.84c-1.8-1.47-2.94-2.78-3.1-3.27l2.29-1.63l-7.68-44.93 c-0.65,1.63-1.14,3.43-1.96,4.9L391.9,298.21z"
}), React.createElement("path", {
  className: "st2",
  d: "M316.42,249.03l4.9,34.96l4.25,0.82l-5.88-44.93c-0.49-2.45-1.47-5.23-2.78-8.01l-3.43-25.16 c-1.14-0.82-2.12-1.47-2.94-2.12l5.06,36.76l3.76,1.14C318.38,244.94,317.4,247.07,316.42,249.03z"
}), React.createElement("path", {
  className: "st2",
  d: "M274.76,225.17c5.88-5.72,12.42-5.88,13.4-5.88c13.07-2.61,20.1,6.86,23.53,14.21l0.98,6.86l2.29,0.65 c-2.78-9.48-10.29-27.94-27.28-24.51c0,0-22.38-0.16-24.02,33.17l3.43-4.57C268.06,236.77,270.34,229.59,274.76,225.17z"
}), React.createElement("path", {
  className: "st2",
  d: "M321.32,283.99l-4.9-34.96c-0.65,1.31-1.47,2.61-2.12,3.76l4.25,30.55L321.32,283.99z"
}), React.createElement("path", {
  className: "st2",
  d: "M399.42,299.68l-8.82-55.39c-0.98-0.49-2.12-0.82-2.94-1.31l8.99,56.04L399.42,299.68z"
}), React.createElement("path", {
  className: "st2",
  d: "M435.69,236.77l20.42,74.5l2.94,0.65L437.65,234c-0.33,0.65-0.49,1.14-0.82,1.8 C436.5,236.12,435.85,236.28,435.69,236.77z"
}), React.createElement("rect", {
  x: 318.87,
  y: 248.86,
  className: "st2",
  width: 0,
  height: 35.29
}), React.createElement("path", {
  className: "st2",
  d: "M266.1,258.34c-0.82-0.49-1.96-1.14-2.78-1.47c0.16,3.92,0.33,9.15,0.65,15.52l2.78,0.49 C266.42,267.16,266.26,262.26,266.1,258.34z"
}), React.createElement("path", {
  className: "st2",
  d: "M627.33,696.53C605.6,832.63,536.66,851.58,536,851.74l-1.8,0.49l-11.11,99.17 c-86.76,28.76-145.41,24.51-179.39,15.85c-32.68-8.33-49.5-22.22-53.1-25.49l-2.78-83.98v-0.98l-0.65-0.82 c-11.6-12.58-26.14-54.41-31.86-71.72c-2.45-7.68-4.57-15.36-5.88-22.87c-23.85-125.15-30.72-226.61-30.72-302.25 c-0.98-0.49-1.8-0.82-2.78-1.14c0,74.17,6.54,176.29,30.88,304.05c1.47,7.84,3.59,15.68,6.05,23.2 c6.7,20.42,20.75,59.96,32.35,72.7l2.78,84.96c0,0,66.33,67.8,237.56,10.46l11.11-99.01c0,0,71.07-17.65,93.45-157.5 c0.49-2.78,0.82-5.23,1.31-7.84c-0.82-0.33-1.63-0.49-2.61-0.82C628.31,691.14,627.82,693.59,627.33,696.53z"
}), React.createElement("polygon", {
  className: "st2",
  points: "414.61,375.32 412.65,359.64 405.3,313.73 401.54,313.07 411.34,374.18  "
}), React.createElement("polygon", {
  className: "st2",
  points: "336.84,350.49 329.65,298.53 327.2,298.04 334.06,349.51  "
}), React.createElement("polygon", {
  className: "st2",
  points: "418.53,455.38 406.77,386.43 403.01,385.29 414.61,454.07  "
}), React.createElement("polygon", {
  className: "st2",
  points: "320.34,296.57 316.58,295.92 323.61,346.24 327.36,347.38  "
}), React.createElement("polygon", {
  className: "st2",
  points: "404.32,372.05 394.19,311.6 390.27,310.79 400.56,370.75  "
}), React.createElement("path", {
  className: "st2",
  d: "M287.34,487.89c-1.31-0.49-2.45-0.98-3.76-1.47l3.59,42.81h-0.16l0,0l3.76-0.33L287.34,487.89z"
}), React.createElement("path", {
  className: "st2",
  d: "M277.86,483.97c-1.31-0.49-2.45-0.98-3.76-1.63c1.63,18.46,2.94,33,3.59,41.01c1.31,0.82,2.45,1.63,3.92,2.45 C280.8,519.1,279.49,503.9,277.86,483.97z"
}), React.createElement("polygon", {
  className: "st2",
  points: "338.96,365.52 336.02,364.7 344.68,429.56 347.95,430.71  "
}), React.createElement("polygon", {
  className: "st2",
  points: "425.07,494.1 425.07,494.1 420.98,469.92 417.06,468.61 421.47,494.59 430.29,493.28 430.29,493.28  "
}), React.createElement("path", {
  className: "st2",
  d: "M242.08,305.56c14.21-3.59,17.65,6.05,18.3,8.17c0.16,2.29,0.33,4.57,0.49,6.86l3.76,1.14 c-0.16-2.78-0.49-5.72-0.65-8.33c0-0.16-1.14-4.08-4.41-7.35c-4.41-4.57-10.62-5.88-18.46-4.08c-0.33,0.16-8.01,2.78-11.6,13.07 c1.14,0.65,2.12,1.14,3.1,1.63C235.54,308.17,241.43,305.72,242.08,305.56z"
}), React.createElement("path", {
  className: "st2",
  d: "M229.17,338.72c-1.31-0.49-2.45-0.98-3.43-1.47c-1.63,13.07-3.27,29.41-4.57,49.18l3.59,1.31 C225.9,367.97,227.54,351.63,229.17,338.72z"
}), React.createElement("polygon", {
  className: "st2",
  points: "424.74,457.5 425.56,457.83 416.57,389.37 413.63,388.56  "
}), React.createElement("polygon", {
  className: "st2",
  points: "354.16,501.13 357.92,502.6 350.07,445.58 346.64,444.43  "
}), React.createElement("polygon", {
  className: "st2",
  points: "336.68,441 344.52,497.2 348.28,498.84 340.44,442.31  "
}), React.createElement("polygon", {
  className: "st2",
  points: "429.48,487.4 427.52,472.04 427.03,471.88  "
}), React.createElement("path", {
  className: "st2",
  d: "M223.78,402.28l-3.59-1.14c-0.65,13.56-1.14,28.43-1.31,44.6c1.14,0.49,2.29,0.98,3.59,1.63 C222.64,430.87,223.13,415.84,223.78,402.28z"
}), React.createElement("path", {
  className: "st2",
  d: "M270.67,329.08v0.33l3.76,1.14l-0.82-10.13c-0.98-12.42-1.63-23.69-2.29-33.66l-3.59-0.82 c0.65,9.31,1.31,19.44,2.12,31.04l0.49,6.54l2.45,0.82C272.14,326.14,271.32,327.61,270.67,329.08z"
}), React.createElement("polygon", {
  className: "st2",
  points: "280.64,407.18 275.57,346.08 271.98,344.93 277.04,405.87  "
}), React.createElement("path", {
  className: "st2",
  d: "M350.4,513.54c-1.31-0.49-2.61-0.98-3.92-1.63l0.33,2.12L350.4,513.54L350.4,513.54L350.4,513.54z"
}), React.createElement("polygon", {
  className: "st2",
  points: "338.47,427.44 329.49,362.58 325.57,361.43 334.55,425.97  "
}), React.createElement("path", {
  className: "st2",
  d: "M627.33,674.64c1.14,0.33,2.29,0.65,3.59,1.14c11.27-66.82,22.22-112.57,33.49-138.87 c-1.31-0.49-2.29-1.14-3.27-1.63C652,556.84,640.57,596.7,627.33,674.64z"
}), React.createElement("path", {
  className: "st2",
  d: "M674.22,513.22c-2.29,2.45-4.74,5.88-7.52,10.78c0.65,0.49,1.31,0.98,2.78,1.47l-1.8,5.06 c3.1-6.21,6.21-11.44,9.31-14.87c5.23-5.88,8.33-12.58,8.99-19.12c-1.14,0.49-2.45,1.47-4.25,2.94 C680.59,504.23,678.14,508.97,674.22,513.22z"
}), React.createElement("path", {
  className: "st2",
  d: "M674.88,473.68c-10.78-5.39-27.77-3.27-49.34,6.05c-1.47,0.65-2.78,1.47-4.08,2.12 c0.82,0.98,1.63,1.96,2.12,3.27c1.14-0.65,2.12-1.47,3.27-1.96c20.26-8.82,36.76-10.95,46.24-6.21c3.59,1.8,5.72,4.74,7.35,8.5 c1.14-0.65,2.29-0.98,3.27-1.31C681.9,479.4,679.12,475.8,674.88,473.68z"
}), React.createElement("polygon", {
  className: "st2",
  points: "281.94,422.21 278.19,420.91 282.43,472.04 286.19,473.68  "
}), React.createElement("path", {
  className: "st2",
  d: "M262.5,341.99c1.47,19.44,3.1,40.19,4.9,60.61l3.76,1.31c-1.63-20.42-3.43-41.17-4.9-60.78L262.5,341.99z"
}), React.createElement("path", {
  className: "st2",
  d: "M272.31,418.94l-3.76-1.31c1.47,17.97,2.94,35.13,4.25,50.48l3.76,1.47 C275.25,454.23,273.78,437.08,272.31,418.94z"
}), React.createElement("path", {
  className: "st2",
  d: "M688.76,492.79l-0.33,2.94c0,0-0.98,0.16-2.45,0.82c-0.82,6.54-3.76,13.23-8.99,19.12 c-3.1,3.43-6.21,8.66-9.31,14.87l-2.29,6.86c-0.33-0.16-0.49-0.33-0.82-0.49c-11.27,26.3-22.22,72.05-33.49,138.87 c0.82,0.33,1.63,0.49,2.61,0.82c17.81-105.54,32.68-144.92,45.58-159.13C685.17,510.44,688.93,501.62,688.76,492.79z"
}), React.createElement("polygon", {
  className: "st2",
  points: "278.19,420.91 275.41,420.09 279.66,470.9 282.43,472.04  "
}), React.createElement("polygon", {
  className: "st2",
  points: "421.8,456.52 424.74,457.5 413.63,388.56 410.69,387.58  "
}), React.createElement("polygon", {
  className: "st2",
  points: "336.02,364.7 332.27,363.39 341.25,428.42 344.68,429.56  "
}), React.createElement("polygon", {
  className: "st2",
  points: "407.26,372.87 396.96,312.09 394.19,311.6 404.32,372.05  "
}), React.createElement("path", {
  className: "st2",
  d: "M267.4,322.71l-0.82-9.15C266.91,316.5,267.08,319.61,267.4,322.71L267.4,322.71z"
}), React.createElement("polygon", {
  className: "st2",
  points: "421.47,456.36 409.71,387.25 406.77,386.43 418.53,455.38  "
}), React.createElement("rect", {
  x: 347.3,
  y: 442.96,
  className: "st2",
  width: 0,
  height: 57.18
}), React.createElement("path", {
  className: "st2",
  d: "M225.74,337.25c-1.31-0.65-1.96-0.98-2.61-1.31c-1.47,11.11-3.27,27.77-4.74,49.5l2.78,0.98 C222.31,366.66,223.94,350.16,225.74,337.25z"
}), React.createElement("polygon", {
  className: "st2",
  points: "334.06,349.51 327.2,298.04 323.12,297.23 330.14,348.36  "
}), React.createElement("polygon", {
  className: "st2",
  points: "351.22,499.98 354.16,501.13 346.64,444.43 343.38,443.29  "
}), React.createElement("polygon", {
  className: "st2",
  points: "330.14,348.36 323.12,297.23 320.34,296.57 327.36,347.38  "
}), React.createElement("rect", {
  x: 326.71,
  y: 296.9,
  className: "st2",
  width: 0,
  height: 51.63
}), React.createElement("path", {
  className: "st2",
  d: "M223.78,330.07c-0.16,0.98-0.33,1.8-0.49,2.94l1.47-2.61L223.78,330.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M241.26,302.13c7.84-1.96,14.05-0.49,18.46,4.08c3.1,3.27,4.25,7.19,4.41,7.35c0.16,2.61,0.49,5.55,0.65,8.33 l2.78,0.82c-0.16-3.1-0.49-6.21-0.65-9.15v-0.33c0,0-4.41-18.95-26.14-13.72c0,0-8.82,2.78-13.23,14.38 c0.82,0.49,1.47,0.98,2.29,1.31C233.26,304.74,240.77,302.13,241.26,302.13z"
}), React.createElement("polygon", {
  className: "st2",
  points: "424.09,470.9 427.68,493.61 423.92,470.9 420.98,469.92 425.07,494.1 425.07,494.1 430.29,493.28  429.48,487.4 427.03,471.88  "
}), React.createElement("path", {
  className: "st2",
  d: "M267.4,322.71l2.78,0.82l-0.49-6.54c-0.82-11.44-1.47-21.73-2.12-31.04l-2.78-0.49 c0.49,8.5,1.14,17.81,1.96,28.1L267.4,322.71z"
}), React.createElement("polygon", {
  className: "st2",
  points: "348.28,498.84 351.22,499.98 343.38,443.29 340.44,442.31  "
}), React.createElement("path", {
  className: "st2",
  d: "M350.4,513.54L350.4,513.54L350.4,513.54z"
}), React.createElement("path", {
  className: "st2",
  d: "M270.67,329.08c0,0.16-0.16,0.16-0.16,0.33h0.16V329.08z"
}), React.createElement("path", {
  className: "st2",
  d: "M284.4,527.59c0.82,0.49,1.8,1.14,2.61,1.63h0.16l-3.59-42.81c-0.98-0.33-1.8-0.82-2.78-1.14L284.4,527.59z"
}), React.createElement("path", {
  className: "st2",
  d: "M275.08,419.92l-2.78-0.98c1.47,18.14,2.94,35.29,4.25,50.81l2.78,1.14 C278.02,455.38,276.55,438.06,275.08,419.92z"
}), React.createElement("path", {
  className: "st2",
  d: "M625.53,479.56c21.57-9.31,38.56-11.44,49.34-6.05c4.25,2.12,7.03,5.88,8.99,10.29 c1.14-0.33,2.12-0.49,2.94-0.65c-6.7-16.66-28.1-20.91-62.25-6.05c-1.63,0.65-3.1,1.63-4.74,2.45c0.65,0.49,1.14,1.47,1.63,2.12 C622.76,481.03,624.06,480.21,625.53,479.56z"
}), React.createElement("path", {
  className: "st2",
  d: "M269.04,343.95l-2.78-0.82c1.47,19.44,3.1,40.36,4.9,60.78l2.78,0.98 C272.14,384.31,270.51,363.56,269.04,343.95z"
}), React.createElement("rect", {
  x: 336.84,
  y: 363.23,
  className: "st2",
  width: 0,
  height: 65.52
}), React.createElement("polygon", {
  className: "st2",
  points: "341.25,428.42 332.27,363.39 329.49,362.58 338.47,427.44  "
}), React.createElement("path", {
  className: "st2",
  d: "M220.19,401.14l-2.78-0.98c-0.65,13.23-1.14,27.94-1.31,44.28c0.98,0.49,1.8,0.82,2.78,1.14 C219.04,429.56,219.53,414.53,220.19,401.14z"
}), React.createElement("polygon", {
  className: "st2",
  points: "411.34,374.18 401.54,313.07 398.6,312.42 408.4,373.36  "
}), React.createElement("polygon", {
  className: "st2",
  points: "277.04,405.87 271.98,344.93 269.2,344.12 274.27,404.89  "
}), React.createElement("path", {
  className: "st2",
  d: "M269.2,344.12h-0.16c1.47,19.61,3.1,40.36,4.9,60.78l0.33,0.16L269.2,344.12z"
}), React.createElement("path", {
  className: "st2",
  d: "M280.64,485.11c-0.98-0.33-1.8-0.82-2.78-1.14c1.8,19.93,3.1,35.13,3.59,41.83c0.82,0.49,1.96,1.14,2.78,1.8 C283.91,523.18,282.6,507.5,280.64,485.11z"
}), React.createElement("path", {
  className: "st2",
  d: "M284.4,527.59l-3.43-42.32c0,0-0.16,0-0.16-0.16C282.6,507.5,283.91,523.18,284.4,527.59 C284.23,527.59,284.23,527.59,284.4,527.59z"
}), React.createElement("path", {
  className: "st2",
  d: "M275.41,420.09l-0.33-0.16c1.47,18.14,2.94,35.62,4.25,50.97l0.33,0.16L275.41,420.09z"
}), React.createElement("path", {
  className: "st2",
  d: "M544.99,648c1.47,0.49,3.1,1.14,4.74,1.63l25-88.06c0.16-0.65,9.97-56.86,48.85-76.63 c-0.49-1.31-1.47-2.29-2.12-3.27c-40.03,20.91-49.99,78.75-50.16,79.24l-23.53,82.67l-87.74-318.92l-3.92-0.82L544.99,648z"
}), React.createElement("polygon", {
  className: "st2",
  points: "415.1,375.49 412.65,359.64 414.61,375.32  "
}), React.createElement("polygon", {
  className: "st2",
  points: "429.48,487.4 430.46,493.12 430.29,493.28 430.29,493.28 434.05,492.63 430.95,473.19 427.52,472.04  "
}), React.createElement("polygon", {
  className: "st2",
  points: "425.56,457.83 428.5,458.81 417.39,389.7 416.57,389.37  "
}), React.createElement("path", {
  className: "st2",
  d: "M571.29,561.09c0.16-0.65,10.13-58.49,50.16-79.24c-0.49-0.65-0.98-1.63-1.63-2.12 c-41.34,21.89-51.14,81.04-51.14,81.04l-20.91,73.19l-84.96-308.63l-2.94-0.65l87.74,318.92L571.29,561.09z"
}), React.createElement("polygon", {
  className: "st2",
  points: "430.46,493.12 429.48,487.4 430.29,493.28  "
}), React.createElement("polygon", {
  className: "st2",
  points: "405.62,379.41 405.62,379.08 401.7,377.77 401.7,378.26  "
}), React.createElement("polygon", {
  className: "st2",
  points: "337.98,358.66 337.82,357.35 335.04,356.53 335.21,357.68  "
}), React.createElement("polygon", {
  className: "st2",
  points: "328.51,355.72 328.34,354.41 324.42,353.1 324.75,354.57  "
}), React.createElement("polygon", {
  className: "st2",
  points: "275.08,339.21 274.92,337.42 271.16,336.11 271.32,338.07  "
}), React.createElement("polygon", {
  className: "st2",
  points: "412.49,381.53 415.59,382.51 415.59,382.18 412.49,381.2  "
}), React.createElement("path", {
  className: "st2",
  d: "M222.15,482.34c0,0.33-0.82,4.74,0.82,10.46c-0.16-4.08-0.16-8.17-0.33-12.09 C222.47,481.36,222.15,481.68,222.15,482.34z"
}), React.createElement("path", {
  className: "st2",
  d: "M228.52,324.51c0.49,0.33,1.63,0.82,2.45,1.14l0,0c0.16-0.65,0.16-1.47,0.33-1.96l0.16-0.65 c-0.98-0.49-2.12-0.98-3.43-1.63l-0.33,1.8c0,0.49-0.16,0.98-0.16,1.47l0.82,0.33L228.52,324.51z"
}), React.createElement("path", {
  className: "st2",
  d: "M222.47,454.07c-1.14-0.49-2.45-1.14-3.59-1.47c0,2.29,0,4.57,0,6.86c1.14,0.49,2.45,0.98,3.59,1.47 C222.47,458.65,222.47,456.2,222.47,454.07z"
}), React.createElement("polygon", {
  className: "st2",
  points: "328.67,291.83 327.85,285.3 325.57,284.81 326.38,291.34  "
}), React.createElement("path", {
  className: "st2",
  d: "M625.21,687.22c1.14,0.33,2.29,0.65,3.59,0.98c0.33-2.12,0.65-4.08,0.98-6.21c-1.14-0.33-2.29-0.65-3.59-1.14 C626.02,682.97,625.53,685.09,625.21,687.22z"
}), React.createElement("path", {
  className: "st2",
  d: "M270.34,273.7l-3.59-0.82c0.16,2.12,0.16,4.08,0.33,6.37l3.59,0.82C270.67,277.95,270.51,275.82,270.34,273.7z "
}), React.createElement("polygon", {
  className: "st2",
  points: "319.36,290.04 318.54,283.5 314.78,282.68 315.6,289.22  "
}), React.createElement("polygon", {
  className: "st2",
  points: "452.84,313.07 456.93,314.05 456.11,311.28 452.19,310.46  "
}), React.createElement("polygon", {
  className: "st2",
  points: "265.61,336.11 265.44,336.27 265.61,336.44  "
}), React.createElement("polygon", {
  className: "st2",
  points: "389.12,304.09 393.04,304.9 391.9,298.21 388.14,297.55  "
}), React.createElement("polygon", {
  className: "st2",
  points: "404.15,307.19 403.17,300.49 399.42,299.68 400.4,306.38  "
}), React.createElement("polygon", {
  className: "st2",
  points: "412.49,381.53 412.49,381.2 409.55,380.22 409.55,380.71  "
}), React.createElement("polygon", {
  className: "st2",
  points: "408.56,380.39 408.4,379.9 405.62,379.08 405.62,379.41  "
}), React.createElement("path", {
  className: "st2",
  d: "M227.54,323.04l0.33-1.8c-0.82-0.49-1.63-0.98-2.45-1.47c0,0.16,0,0.16-0.16,0.33 c-0.16,0.82-0.33,2.12-0.49,3.43l2.61,0.98C227.38,324.18,227.54,323.53,227.54,323.04z"
}), React.createElement("polygon", {
  className: "st2",
  points: "399.42,299.68 396.47,299.19 397.62,305.72 400.4,306.38  "
}), React.createElement("polygon", {
  className: "st2",
  points: "395.82,305.39 394.68,298.86 391.9,298.21 393.04,304.9  "
}), React.createElement("polygon", {
  className: "st2",
  points: "326.38,291.34 325.57,284.81 321.32,283.99 322.14,290.53  "
}), React.createElement("polygon", {
  className: "st2",
  points: "271.32,338.07 271.16,336.11 268.55,335.29 268.71,337.25  "
}), React.createElement("rect", {
  x: 321.81,
  y: 283.99,
  className: "st2",
  width: 0,
  height: 6.7
}), React.createElement("rect", {
  x: 331.29,
  y: 355.23,
  className: "st2",
  width: 0,
  height: 1.31
}), React.createElement("polygon", {
  className: "st2",
  points: "335.21,357.68 335.04,356.53 331.12,355.23 331.29,356.53  "
}), React.createElement("polygon", {
  className: "st2",
  points: "322.14,290.53 321.32,283.99 318.54,283.5 319.36,290.04  "
}), React.createElement("polygon", {
  className: "st2",
  points: "331.12,355.23 328.34,354.41 328.51,355.72 331.29,356.53  "
}), React.createElement("path", {
  className: "st2",
  d: "M268.38,337.25h0.16l-0.16-1.96h-0.16C268.38,335.95,268.38,336.6,268.38,337.25z"
}), React.createElement("path", {
  className: "st2",
  d: "M265.61,336.11v0.16l2.78,0.82c0-0.65-0.16-1.31-0.16-1.96l-1.47-0.49 C266.42,335.29,266.1,335.78,265.61,336.11z"
}), React.createElement("polygon", {
  className: "st2",
  points: "456.93,314.05 459.87,314.87 459.05,311.77 456.11,311.28  "
}), React.createElement("path", {
  className: "st2",
  d: "M266.75,273.05l-2.78-0.49c0.16,2.12,0.16,4.08,0.33,6.37l2.78,0.49 C266.91,277.13,266.91,275.17,266.75,273.05z"
}), React.createElement("path", {
  className: "st2",
  d: "M218.88,452.44c-0.82-0.33-1.96-0.82-2.78-1.14c0,2.29,0,4.57,0,6.86c0.98,0.49,1.8,0.82,2.78,1.14 C218.88,457.01,218.72,454.72,218.88,452.44z"
}), React.createElement("path", {
  className: "st2",
  d: "M628.8,688.36c0.82,0.33,1.63,0.49,2.61,0.82c0.33-2.12,0.65-4.25,0.98-6.21c-0.82-0.33-1.63-0.49-2.61-0.82 C629.46,684.11,629.13,686.07,628.8,688.36z"
}), React.createElement("polygon", {
  className: "st2",
  points: "344.68,429.56 345.66,436.59 348.93,437.73 347.95,430.71  "
}), React.createElement("polygon", {
  className: "st2",
  points: "415.92,461.42 417.06,468.61 420.98,469.92 419.84,462.73  "
}), React.createElement("polygon", {
  className: "st2",
  points: "345.66,437.41 346.64,444.43 350.07,445.58 349.09,438.55  "
}), React.createElement("polygon", {
  className: "st2",
  points: "414.61,454.07 415.75,461.1 419.67,462.4 418.53,455.38  "
}), React.createElement("path", {
  className: "st2",
  d: "M355.63,512.89l3.59-0.49l-0.33-2.12c-1.31-0.49-2.61-0.98-3.92-1.47L355.63,512.89z"
}), React.createElement("path", {
  className: "st2",
  d: "M355.14,508.64c1.31,0.49,2.61,0.98,3.92,1.47v-0.33l-3.92-1.63V508.64z"
}), React.createElement("polygon", {
  className: "st2",
  points: "355.14,508.31 358.9,509.78 357.92,502.6 354.16,501.13  "
}), React.createElement("polygon", {
  className: "st2",
  points: "415.59,382.18 414.61,375.32 411.34,374.18 412.49,381.2  "
}), React.createElement("polygon", {
  className: "st2",
  points: "405.62,379.08 404.32,372.05 400.56,370.75 401.7,377.77  "
}), React.createElement("path", {
  className: "st2",
  d: "M265.61,336.44L265.61,336.44c-1.31,0.98-2.29,1.8-3.43,2.61c0,0.98,0.16,1.96,0.16,3.1l3.76,1.14 C266.1,340.85,265.93,338.56,265.61,336.44z"
}), React.createElement("polygon", {
  className: "st2",
  points: "337.82,357.35 336.84,350.49 334.06,349.51 335.04,356.53  "
}), React.createElement("polygon", {
  className: "st2",
  points: "427.03,471.88 427.52,472.04 426.54,465.18 425.88,464.85  "
}), React.createElement("polygon", {
  className: "st2",
  points: "275.57,346.08 275.08,339.21 271.32,338.07 271.98,344.93  "
}), React.createElement("polygon", {
  className: "st2",
  points: "329.49,362.58 328.51,355.72 324.75,354.57 325.57,361.43  "
}), React.createElement("polygon", {
  className: "st2",
  points: "425.88,464.53 426.54,464.85 425.56,457.83 424.74,457.5  "
}), React.createElement("polygon", {
  className: "st2",
  points: "425.88,464.85 426.54,465.18 426.54,464.85 425.88,464.53  "
}), React.createElement("polygon", {
  className: "st2",
  points: "319.36,290.04 315.6,289.22 316.58,295.92 320.34,296.57  "
}), React.createElement("polygon", {
  className: "st2",
  points: "413.63,388.56 416.57,389.37 415.59,382.51 412.49,381.53  "
}), React.createElement("polygon", {
  className: "st2",
  points: "406.77,386.43 405.62,379.41 401.7,378.26 403.01,385.29  "
}), React.createElement("path", {
  className: "st2",
  d: "M345.5,504.39v0.49c1.31,0.49,2.61,0.98,3.92,1.63v-0.49L345.5,504.39z"
}), React.createElement("polygon", {
  className: "st2",
  points: "415.75,461.1 415.92,461.42 419.84,462.73 419.67,462.4  "
}), React.createElement("polygon", {
  className: "st2",
  points: "345.66,436.59 345.66,437.41 349.09,438.55 348.93,437.73  "
}), React.createElement("polygon", {
  className: "st2",
  points: "344.52,497.2 345.5,504.39 349.26,505.86 348.28,498.84  "
}), React.createElement("polygon", {
  className: "st2",
  points: "339.45,434.47 338.47,427.44 334.55,425.97 335.53,433  "
}), React.createElement("path", {
  className: "st2",
  d: "M224.11,395.74l-3.59-1.14c-0.16,2.29-0.33,4.25-0.33,6.54l3.59,1.14 C223.78,399.99,223.94,398.03,224.11,395.74z"
}), React.createElement("path", {
  className: "st2",
  d: "M282.92,479.07v0.33c1.31,0.49,2.45,0.98,3.76,1.47v-0.33L282.92,479.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M222.47,447.21c-1.31-0.49-2.45-0.98-3.59-1.63c0,2.29,0,4.57,0,6.86c1.14,0.49,2.45,0.98,3.59,1.47 C222.47,451.78,222.47,449.33,222.47,447.21z"
}), React.createElement("polygon", {
  className: "st2",
  points: "281.29,414.04 280.64,407.18 277.04,405.87 277.53,412.74  "
}), React.createElement("path", {
  className: "st2",
  d: "M349.42,506.35c-1.31-0.49-2.61-0.98-3.92-1.63l0.98,7.19c1.31,0.49,2.61,0.98,3.92,1.63L349.42,506.35z"
}), React.createElement("path", {
  className: "st2",
  d: "M626.35,681.01c1.14,0.33,2.29,0.65,3.59,1.14c0.33-2.12,0.65-4.25,0.98-6.21c-1.14-0.33-2.29-0.65-3.59-1.14 C627.01,676.76,626.68,678.88,626.35,681.01z"
}), React.createElement("polygon", {
  className: "st2",
  points: "340.44,442.31 339.62,435.28 335.7,433.98 336.68,441  "
}), React.createElement("path", {
  className: "st2",
  d: "M230.81,325.65L230.81,325.65L230.81,325.65z"
}), React.createElement("polygon", {
  className: "st2",
  points: "338.96,365.52 337.98,358.66 335.21,357.68 336.02,364.7  "
}), React.createElement("path", {
  className: "st2",
  d: "M283.09,479.4l0.65,7.03c1.31,0.49,2.45,0.98,3.76,1.47l-0.65-7.03C285.54,480.38,284.23,479.89,283.09,479.4z "
}), React.createElement("polygon", {
  className: "st2",
  points: "281.29,414.04 277.53,412.74 277.7,414.04 281.29,415.35  "
}), React.createElement("path", {
  className: "st2",
  d: "M270.83,280.23l-3.59-0.82c0.16,1.96,0.33,4.41,0.49,6.54l3.59,0.82C271,284.48,270.83,282.36,270.83,280.23z"
}), React.createElement("path", {
  className: "st2",
  d: "M271,403.91l-3.76-1.31c0.16,2.29,0.33,4.57,0.49,6.86l3.76,1.31C271.49,408.49,271.32,406.2,271,403.91z"
}), React.createElement("polygon", {
  className: "st2",
  points: "281.29,415.35 277.7,414.04 278.19,420.91 281.94,422.21  "
}), React.createElement("polygon", {
  className: "st2",
  points: "339.62,435.28 339.45,434.47 335.53,433 335.7,433.98  "
}), React.createElement("polygon", {
  className: "st2",
  points: "282.43,472.04 282.92,479.07 286.68,480.54 286.19,473.68  "
}), React.createElement("path", {
  className: "st2",
  d: "M227.38,324.51c-0.16,0.65-0.16,1.47-0.33,2.29l1.14-1.96L227.38,324.51z"
}), React.createElement("path", {
  className: "st2",
  d: "M220.68,392.97c0,0.49,0,1.14-0.16,1.63l3.59,1.14c0-0.49,0-0.98,0.16-1.63L220.68,392.97z"
}), React.createElement("path", {
  className: "st2",
  d: "M277.21,476.94c-1.31-0.49-2.61-0.98-3.76-1.47c0.16,2.45,0.49,4.74,0.65,7.03c1.31,0.49,2.45,0.98,3.76,1.63 C277.53,481.68,277.37,479.4,277.21,476.94z"
}), React.createElement("path", {
  className: "st2",
  d: "M277.21,476.94L277.21,476.94l-3.76-1.63v0.16C274.59,475.8,275.9,476.45,277.21,476.94z"
}), React.createElement("path", {
  className: "st2",
  d: "M271.65,412.08l-3.76-1.31c0.16,2.29,0.33,4.57,0.49,6.86l3.76,1.31 C272.14,416.66,271.98,414.37,271.65,412.08z"
}), React.createElement("path", {
  className: "st2",
  d: "M276.55,469.76l-3.76-1.47c0.16,2.45,0.33,4.74,0.65,7.03l3.76,1.47 C277.04,474.49,276.72,472.04,276.55,469.76z"
}), React.createElement("path", {
  className: "st2",
  d: "M231.46,321.08c0.33-1.8,0.82-2.94,1.31-4.41c-0.98-0.49-1.96-0.98-3.1-1.63c-0.65,1.8-1.31,3.27-1.63,5.39 l-0.16,0.82c1.14,0.65,2.45,1.14,3.43,1.63L231.46,321.08z"
}), React.createElement("polygon", {
  className: "st2",
  points: "327.36,347.38 323.61,346.24 324.42,353.1 328.34,354.41  "
}), React.createElement("path", {
  className: "st2",
  d: "M224.6,387.58l-3.59-1.31c-0.16,2.12-0.33,4.41-0.33,6.54l3.59,1.31C224.27,391.99,224.43,389.7,224.6,387.58z "
}), React.createElement("path", {
  className: "st2",
  d: "M281.78,529.72L281.78,529.72c0-0.65-0.16-1.96-0.33-3.76c-1.31-0.82-2.45-1.63-3.92-2.45 c0.33,3.27,0.49,5.72,0.65,6.54l8.82-0.82l0,0L281.78,529.72z"
}), React.createElement("polygon", {
  className: "st2",
  points: "394.19,311.6 393.04,304.9 389.12,304.09 390.27,310.79  "
}), React.createElement("polygon", {
  className: "st2",
  points: "274.92,337.42 274.27,330.56 270.67,329.41 271.16,336.11  "
}), React.createElement("polygon", {
  className: "st2",
  points: "329.65,298.53 328.67,291.83 326.38,291.34 327.2,298.04  "
}), React.createElement("polygon", {
  className: "st2",
  points: "404.15,307.19 400.4,306.38 401.54,313.07 405.3,313.73  "
}), React.createElement("path", {
  className: "st2",
  d: "M271.65,410.78l-3.76-1.31c0,0.49,0,0.98,0.16,1.31l3.76,1.31C271.65,411.59,271.65,411.1,271.65,410.78z"
}), React.createElement("path", {
  className: "st2",
  d: "M217.74,393.62c-0.16,2.12-0.16,4.25-0.33,6.54l2.78,0.98c0.16-2.29,0.33-4.25,0.33-6.54L217.74,393.62z"
}), React.createElement("polygon", {
  className: "st2",
  points: "320.34,296.57 323.12,297.23 322.14,290.53 319.36,290.04  "
}), React.createElement("path", {
  className: "st2",
  d: "M349.42,506.35l0.98,7.19l0,0l2.61-0.33l-0.82-5.72C351.38,507.17,350.4,506.68,349.42,506.35z"
}), React.createElement("rect", {
  x: 322.63,
  y: 290.53,
  className: "st2",
  width: 0,
  height: 6.7
}), React.createElement("path", {
  className: "st2",
  d: "M352.2,507.5c0.98,0.33,1.96,0.82,2.94,1.14v-0.49l-2.94-1.14V507.5z"
}), React.createElement("rect", {
  x: 331.78,
  y: 356.53,
  className: "st2",
  width: 0,
  height: 7.03
}), React.createElement("rect", {
  x: 352.2,
  y: 507.17,
  className: "st2",
  width: 0,
  height: 0.49
}), React.createElement("rect", {
  x: 352.69,
  y: 507.5,
  className: "st2",
  width: 0,
  height: 5.72
}), React.createElement("polygon", {
  className: "st2",
  points: "352.2,507.17 355.14,508.31 354.16,501.13 351.22,499.98  "
}), React.createElement("polygon", {
  className: "st2",
  points: "424.09,470.9 427.03,471.88 425.88,464.85 422.94,463.87  "
}), React.createElement("polygon", {
  className: "st2",
  points: "410.69,387.58 413.63,388.56 412.49,381.53 409.55,380.71  "
}), React.createElement("path", {
  className: "st2",
  d: "M227.05,326.8c0.16-0.82,0.16-1.63,0.33-2.29l-2.61-0.82c-0.33,1.63-0.49,3.76-0.98,6.37l1.14,0.33 L227.05,326.8z"
}), React.createElement("polygon", {
  className: "st2",
  points: "422.94,463.87 425.88,464.85 425.88,464.53 422.94,463.55  "
}), React.createElement("path", {
  className: "st2",
  d: "M268.55,335.29l2.78,0.82l-0.49-6.86h-0.16c-0.65,1.31-1.47,2.61-2.29,3.59L268.55,335.29z"
}), React.createElement("polygon", {
  className: "st2",
  points: "419.67,462.4 419.84,462.73 422.62,463.71 422.62,463.55  "
}), React.createElement("polygon", {
  className: "st2",
  points: "343.38,443.29 346.64,444.43 345.66,437.41 342.4,436.26  "
}), React.createElement("path", {
  className: "st2",
  d: "M227.87,320.59c0.33-2.29,1.14-3.76,1.63-5.39c-0.82-0.49-1.47-0.82-2.29-1.31c-0.65,1.96-1.63,3.59-1.96,6.21 c0.82,0.49,1.63,0.98,2.45,1.47L227.87,320.59z"
}), React.createElement("polygon", {
  className: "st2",
  points: "342.23,435.45 342.4,436.26 345.66,437.41 345.66,436.59  "
}), React.createElement("path", {
  className: "st2",
  d: "M220.68,392.97c0.16-2.12,0.33-4.41,0.33-6.54l-2.78-0.98c-0.16,2.12-0.33,4.25-0.49,6.54L220.68,392.97z"
}), React.createElement("polygon", {
  className: "st2",
  points: "396.96,312.09 395.82,305.39 393.04,304.9 394.19,311.6  "
}), React.createElement("polygon", {
  className: "st2",
  points: "422.94,463.55 425.88,464.53 424.74,457.5 421.8,456.52  "
}), React.createElement("rect", {
  x: 351.71,
  y: 499.82,
  className: "st2",
  width: 0,
  height: 7.19
}), React.createElement("polygon", {
  className: "st2",
  points: "340.44,442.31 343.38,443.29 342.4,436.26 339.62,435.28  "
}), React.createElement("polygon", {
  className: "st2",
  points: "335.21,357.68 331.29,356.53 332.27,363.39 336.02,364.7  "
}), React.createElement("polygon", {
  className: "st2",
  points: "348.28,498.84 349.26,505.86 352.2,507.17 351.22,499.98  "
}), React.createElement("polygon", {
  className: "st2",
  points: "342.4,436.26 342.23,435.45 339.45,434.47 339.62,435.28  "
}), React.createElement("polygon", {
  className: "st2",
  points: "409.71,387.25 408.56,380.39 405.62,379.41 406.77,386.43  "
}), React.createElement("polygon", {
  className: "st2",
  points: "345.66,436.59 344.68,429.56 341.25,428.42 342.23,435.45  "
}), React.createElement("path", {
  className: "st2",
  d: "M629.78,681.99c0.82,0.33,1.63,0.49,2.61,0.82c0.33-2.12,0.65-4.25,0.98-6.21c-0.82-0.33-1.63-0.49-2.61-0.82 C630.6,677.9,630.11,679.86,629.78,681.99z"
}), React.createElement("path", {
  className: "st2",
  d: "M217.9,391.99c0,0.49,0,1.14-0.16,1.63l2.78,0.98c0-0.49,0-1.14,0.16-1.63L217.9,391.99z"
}), React.createElement("path", {
  className: "st2",
  d: "M267.08,279.42l-2.78-0.49c0.16,2.12,0.33,4.25,0.33,6.54l2.78,0.49C267.4,283.83,267.24,281.54,267.08,279.42 z"
}), React.createElement("path", {
  className: "st2",
  d: "M218.88,445.58c-0.98-0.49-1.8-0.82-2.78-1.14c0,2.29,0,4.57,0,6.86c0.82,0.33,1.8,0.82,2.78,1.14 C218.88,450.15,218.88,447.86,218.88,445.58z"
}), React.createElement("polygon", {
  className: "st2",
  points: "418.53,455.38 419.67,462.4 422.62,463.55 421.47,456.36  "
}), React.createElement("path", {
  className: "st2",
  d: "M280.15,477.93v0.33c0.98,0.33,1.8,0.82,2.78,1.14v-0.33L280.15,477.93z"
}), React.createElement("polygon", {
  className: "st2",
  points: "277.7,414.04 274.92,413.23 275.41,420.09 278.19,420.91  "
}), React.createElement("polygon", {
  className: "st2",
  points: "282.43,472.04 279.66,470.9 280.15,477.93 282.92,479.07  "
}), React.createElement("polygon", {
  className: "st2",
  points: "277.53,412.74 274.76,411.76 274.92,413.23 277.7,414.04  "
}), React.createElement("polygon", {
  className: "st2",
  points: "401.54,313.07 400.4,306.38 397.62,305.72 398.6,312.42  "
}), React.createElement("polygon", {
  className: "st2",
  points: "277.04,405.87 274.27,404.89 274.76,411.76 277.53,412.74  "
}), React.createElement("path", {
  className: "st2",
  d: "M352.2,507.17l-2.94-1.14v0.49c0.98,0.33,1.96,0.82,2.94,1.14V507.17z"
}), React.createElement("rect", {
  x: 342.89,
  y: 436.26,
  className: "st2",
  width: 0,
  height: 7.03
}), React.createElement("rect", {
  x: 341.74,
  y: 428.42,
  className: "st2",
  width: 0,
  height: 7.03
}), React.createElement("rect", {
  x: 342.4,
  y: 435.45,
  className: "st2",
  width: 0,
  height: 0.82
}), React.createElement("path", {
  className: "st2",
  d: "M268.06,333.17c-0.49,0.49-0.82,1.14-1.31,1.63l1.47,0.49C268.22,334.48,268.22,333.82,268.06,333.17z"
}), React.createElement("polygon", {
  className: "st2",
  points: "342.23,435.45 341.25,428.42 338.47,427.44 339.45,434.47  "
}), React.createElement("path", {
  className: "st2",
  d: "M268.55,335.29l-0.16-2.29l-0.16,0.16c0,0.65,0.16,1.47,0.16,2.12H268.55z"
}), React.createElement("polygon", {
  className: "st2",
  points: "327.2,298.04 326.38,291.34 322.14,290.53 323.12,297.23  "
}), React.createElement("polygon", {
  className: "st2",
  points: "332.27,363.39 331.29,356.53 328.51,355.72 329.49,362.58  "
}), React.createElement("path", {
  className: "st2",
  d: "M280.31,478.25c0,0-0.16,0-0.33-0.16c0.16,2.45,0.49,4.74,0.65,7.03c0,0,0.16,0,0.16,0.16L280.31,478.25z"
}), React.createElement("path", {
  className: "st2",
  d: "M279.33,470.9l-2.78-1.14c0.16,2.29,0.33,4.74,0.65,7.03l2.78,1.14C279.82,475.47,279.66,473.35,279.33,470.9z "
}), React.createElement("polygon", {
  className: "st2",
  points: "330.14,348.36 327.36,347.38 328.34,354.41 331.12,355.23  "
}), React.createElement("polygon", {
  className: "st2",
  points: "412.49,381.2 411.34,374.18 408.4,373.36 409.55,380.22  "
}), React.createElement("path", {
  className: "st2",
  d: "M273.78,404.89l-2.78-0.98c0.16,2.29,0.33,4.57,0.49,6.86l2.78,0.98C274.27,409.47,274.1,407.18,273.78,404.89 z"
}), React.createElement("path", {
  className: "st2",
  d: "M284.4,529.39c0,0-0.16-0.98-0.16-1.8c-0.98-0.49-1.96-1.14-2.78-1.8c0.16,1.8,0.33,3.27,0.33,3.76l0,0 l5.23-0.49c-0.82-0.49-1.8-1.14-2.61-1.63V529.39z"
}), React.createElement("path", {
  className: "st2",
  d: "M280.31,478.25l0.65,7.03c0.98,0.33,1.8,0.82,2.78,1.14l-0.65-7.03C282.11,478.91,281.13,478.58,280.31,478.25 z"
}), React.createElement("path", {
  className: "st2",
  d: "M280.64,485.11c-0.16-2.29-0.33-4.57-0.65-7.03c-0.98-0.33-1.8-0.82-2.78-1.14c0.16,2.45,0.33,4.74,0.65,7.03 C278.68,484.46,279.66,484.79,280.64,485.11z"
}), React.createElement("path", {
  className: "st2",
  d: "M279.98,477.76l-2.78-1.14v0.16C278.19,477.11,279,477.6,279.98,477.76 C279.98,477.93,279.98,477.93,279.98,477.76z"
}), React.createElement("polygon", {
  className: "st2",
  points: "408.4,379.9 407.26,372.87 404.32,372.05 405.62,379.08  "
}), React.createElement("polygon", {
  className: "st2",
  points: "335.04,356.53 334.06,349.51 330.14,348.36 331.12,355.23  "
}), React.createElement("rect", {
  x: 330.63,
  y: 348.36,
  className: "st2",
  width: 0,
  height: 7.03
}), React.createElement("path", {
  className: "st2",
  d: "M352.2,507.5l0.82,5.72l2.61-0.33l-0.49-4.25C354.16,508.31,353.18,507.82,352.2,507.5z"
}), React.createElement("polygon", {
  className: "st2",
  points: "422.62,463.71 419.84,462.73 420.98,469.92 423.92,470.9  "
}), React.createElement("path", {
  className: "st2",
  d: "M284.4,529.39l-0.16-1.8l0,0C284.4,528.41,284.4,529.39,284.4,529.39z"
}), React.createElement("polygon", {
  className: "st2",
  points: "271.98,344.93 271.32,338.07 268.71,337.25 269.2,344.12  "
}), React.createElement("path", {
  className: "st2",
  d: "M269.2,344.12l-0.49-6.86h-0.16c0.16,2.29,0.33,4.57,0.49,6.7L269.2,344.12z"
}), React.createElement("path", {
  className: "st2",
  d: "M274.43,411.76l-2.78-0.98c0,0.49,0,0.98,0.16,1.31l2.78,0.98C274.43,412.57,274.43,412.08,274.43,411.76z"
}), React.createElement("path", {
  className: "st2",
  d: "M274.76,411.76l-0.33-0.16c0,0.49,0,0.82,0.16,1.31l0.33,0.16L274.76,411.76z"
}), React.createElement("path", {
  className: "st2",
  d: "M274.27,404.89l-0.33-0.16c0.16,2.29,0.33,4.57,0.49,6.86l0.33,0.16L274.27,404.89z"
}), React.createElement("path", {
  className: "st2",
  d: "M274.92,413.23l-0.33-0.16c0.16,2.29,0.33,4.57,0.49,6.86l0.33,0.16L274.92,413.23z"
}), React.createElement("path", {
  className: "st2",
  d: "M274.43,413.06l-2.78-0.98c0.16,2.29,0.33,4.57,0.49,6.86l2.78,0.98 C274.92,417.64,274.76,415.35,274.43,413.06z"
}), React.createElement("path", {
  className: "st2",
  d: "M280.15,477.93l-0.33-0.16c0,0.16,0,0.16,0,0.33c0,0,0.16,0,0.33,0.16V477.93z"
}), React.createElement("path", {
  className: "st2",
  d: "M279.66,470.9l-0.33-0.16c0.16,2.45,0.33,4.57,0.65,7.03l0.33,0.16L279.66,470.9z"
}), React.createElement("path", {
  className: "st2",
  d: "M269.04,343.95c-0.16-2.29-0.33-4.57-0.49-6.7l-2.78-0.82c0.16,2.29,0.33,4.41,0.49,6.7L269.04,343.95z"
}), React.createElement("polygon", {
  className: "st2",
  points: "453.98,317.16 457.91,317.98 456.93,314.05 452.84,313.07  "
}), React.createElement("path", {
  className: "st2",
  d: "M547.93,655.68c-0.33-0.16-0.65-0.16-0.82-0.33l0.49,1.8L547.93,655.68z"
}), React.createElement("polygon", {
  className: "st2",
  points: "416.41,382.67 416.24,382.35 415.59,382.18 415.59,382.51  "
}), React.createElement("polygon", {
  className: "st2",
  points: "457.91,317.98 460.85,318.63 459.87,314.87 456.93,314.05  "
}), React.createElement("path", {
  className: "st2",
  d: "M547.93,655.68l1.8-6.05c-1.63-0.49-3.1-1.14-4.74-1.63l2.12,7.35C547.44,655.52,547.77,655.68,547.93,655.68z "
}), React.createElement("polygon", {
  className: "st2",
  points: "429.8,466.16 429.64,466 426.54,464.85 426.54,465.18  "
}), React.createElement("polygon", {
  className: "st2",
  points: "455.78,324.02 459.87,324.84 457.91,317.98 453.98,317.16  "
}), React.createElement("polygon", {
  className: "st2",
  points: "426.54,464.85 429.64,466 428.5,458.81 425.56,457.83  "
}), React.createElement("polygon", {
  className: "st2",
  points: "415.59,382.51 416.57,389.37 417.39,389.7 416.41,382.67  "
}), React.createElement("polygon", {
  className: "st2",
  points: "426.54,465.18 427.52,472.04 430.95,473.19 429.8,466.16  "
}), React.createElement("polygon", {
  className: "st2",
  points: "415.59,382.18 416.24,382.35 415.1,375.49 414.61,375.32  "
}), React.createElement("polygon", {
  className: "st2",
  points: "459.87,324.84 462.81,325.33 460.85,318.63 457.91,317.98  "
}), React.createElement("path", {
  className: "st2",
  d: "M765.55,523.18l4.41-11.76c-89.7-33-92.47-119.27-92.64-123.03l-12.58,0.33 C664.75,389.54,667.52,487.24,765.55,523.18z"
}), React.createElement("path", {
  className: "st2",
  d: "M258.91,323.86l2.12-0.33c0-0.98-0.16-1.8-0.16-2.78h-0.33C260.21,321.9,259.56,322.88,258.91,323.86z"
}), React.createElement("path", {
  className: "st2",
  d: "M258.09,341.18c0.16,0,0.49-0.16,0.65-0.33l-14.87-4.57c-5.39-0.65-10.29-2.45-13.89-4.08 c-0.33,2.12-0.49,4.25-0.82,6.54c4.9,2.12,11.6,4.25,18.79,4.25C251.23,342.97,254.82,342.48,258.09,341.18z"
}), React.createElement("path", {
  className: "st2",
  d: "M261.85,333.17l-1.96-0.65c-0.65,0.49-1.14,0.98-1.96,1.47l4.08,1.31 C261.85,334.48,261.85,333.82,261.85,333.17z"
}), React.createElement("path", {
  className: "st2",
  d: "M261.85,333.17c0-0.65-0.16-1.47-0.16-2.12c-0.65,0.65-1.31,0.98-1.8,1.47L261.85,333.17z"
}), React.createElement("path", {
  className: "st2",
  d: "M262.01,335.13l-4.08-1.31c-4.25,2.45-9.31,2.94-14.05,2.29l14.87,4.57c1.14-0.49,2.29-1.14,3.59-1.96 C262.18,337.74,262.01,336.44,262.01,335.13z"
}), React.createElement("path", {
  className: "st2",
  d: "M230.81,325.65c-0.16,0.98-0.33,2.29-0.49,3.27l6.05-1.14C234.24,327.12,232.44,326.47,230.81,325.65z"
}), React.createElement("path", {
  className: "st2",
  d: "M222.15,335.29c0.16,0,0.65,0.33,0.98,0.49c0.16-0.82,0.16-1.96,0.33-2.78L222.15,335.29z"
}), React.createElement("path", {
  className: "st2",
  d: "M264.95,327.61c0-0.65-0.16-1.14-0.16-1.63c-0.16,0.49-0.49,0.98-0.82,1.47L264.95,327.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M261.03,323.53l3.59-0.65c0-0.33,0-0.65,0-0.98l-3.76-1.14C261.03,321.57,261.03,322.55,261.03,323.53z"
}), React.createElement("path", {
  className: "st2",
  d: "M272.63,324.35l-2.45-0.82l0.49,5.39C271.32,327.61,272.14,326.14,272.63,324.35z"
}), React.createElement("path", {
  className: "st2",
  d: "M229.99,332.19c-0.49-0.33-0.98-0.49-1.47-0.65l-2.12-0.65c-0.33,1.96-0.49,4.08-0.82,6.21 c0.98,0.49,2.29,0.98,3.43,1.47C229.34,336.44,229.66,334.31,229.99,332.19z"
}), React.createElement("path", {
  className: "st2",
  d: "M266.59,322.55c-0.49,1.47-1.14,2.29-1.8,3.43c0,0.65,0.16,1.14,0.16,1.63l2.78,0.82 c-0.16-1.96-0.33-3.76-0.49-5.72l-2.78-0.82c0,0.33,0,0.65,0,0.98L266.59,322.55z"
}), React.createElement("path", {
  className: "st2",
  d: "M226.56,330.88l-1.47-0.49l-1.47,2.61c-0.16,0.82-0.16,1.96-0.33,2.78c0.65,0.33,1.31,0.65,2.61,1.31 C225.9,334.97,226.23,332.84,226.56,330.88z"
}), React.createElement("path", {
  className: "st2",
  d: "M270.51,329.25c0-0.16,0.16-0.16,0.16-0.33l-0.49-5.39l-2.78-0.82l0.49,5.72L270.51,329.25z"
}), React.createElement("path", {
  className: "st2",
  d: "M267.73,328.43L267.73,328.43l-0.33-5.72l0,0C267.57,324.67,267.57,326.47,267.73,328.43z"
}), React.createElement("path", {
  className: "st2",
  d: "M228.19,324.84l2.61,0.82c-0.82-0.49-1.8-0.82-2.45-1.14L228.19,324.84z"
}), React.createElement("path", {
  className: "st2",
  d: "M262.01,335.13l3.59,1.14c0,0,0.16,0,0.16-0.16c0-0.65-0.16-1.31-0.16-1.8l-3.76-1.14 C261.85,333.82,261.85,334.48,262.01,335.13z"
}), React.createElement("path", {
  className: "st2",
  d: "M266.91,334.8l-1.31-0.49c0,0.65,0.16,1.31,0.16,1.8C266.1,335.78,266.42,335.29,266.91,334.8z"
}), React.createElement("path", {
  className: "st2",
  d: "M226.56,330.56c0,0.16,0,0.16,0,0.33l2.12,0.65C227.7,331.21,227.05,330.88,226.56,330.56z"
}), React.createElement("path", {
  className: "st2",
  d: "M261.69,331.05c0,0.65,0.16,1.47,0.16,2.12l3.76,1.14c-0.16-2.29-0.33-4.57-0.49-6.86l-0.82-0.33 C263.32,328.59,262.67,330.07,261.69,331.05z"
}), React.createElement("path", {
  className: "st2",
  d: "M265.44,336.27l-3.59-1.14c0.16,1.31,0.16,2.45,0.33,3.76C263.32,338.23,264.46,337.42,265.44,336.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M230.48,328.92c0.16-1.14,0.33-2.29,0.49-3.27l0,0l-2.61-0.82l-1.14,1.96c-0.16,0.98-0.33,1.8-0.33,2.78 L230.48,328.92z"
}), React.createElement("path", {
  className: "st2",
  d: "M225.25,329.9l1.31-0.33c0.16-0.98,0.33-1.96,0.33-2.78l-2.12,3.59l1.47,0.49c0-0.16,0-0.16,0-0.33 C225.9,330.23,225.25,329.9,225.25,329.9z"
}), React.createElement("path", {
  className: "st2",
  d: "M268.22,333.01l-0.33-4.41h-0.16c0.16,1.63,0.16,3.1,0.33,4.74C268.22,333.01,268.22,333.01,268.22,333.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M265.61,334.31l1.31,0.49c0.49-0.49,0.82-1.14,1.31-1.63c-0.16-1.63-0.16-3.1-0.33-4.74l-2.78-0.82 C265.12,329.74,265.28,332.03,265.61,334.31z"
}), React.createElement("path", {
  className: "st2",
  d: "M270.51,329.25l-2.61-0.82l0.33,4.41C269.04,331.86,269.85,330.72,270.51,329.25z"
}), React.createElement("path", {
  className: "st2",
  d: "M258.25,325.33l3.1,0.98c0-0.98-0.16-1.96-0.16-2.94l-2.12,0.33C258.74,324.35,258.58,325,258.25,325.33z"
}), React.createElement("path", {
  className: "st2",
  d: "M229.99,332.03v0.16c3.43,1.47,8.5,3.27,13.89,4.08L229.99,332.03z"
}), React.createElement("path", {
  className: "st2",
  d: "M251.07,329.74c-1.96,0.33-3.92,0.49-6.05,0.33l12.91,3.92c0.65-0.33,1.31-0.98,1.96-1.47L251.07,329.74z"
}), React.createElement("path", {
  className: "st2",
  d: "M243.88,336.27c4.9,0.65,9.8,0.16,14.05-2.29l-12.91-3.92c-2.94-0.33-5.88-1.14-8.5-2.12l-6.05,1.14 c-0.16,0.98-0.33,1.96-0.49,2.94L243.88,336.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M253.52,329.41c-0.82,0.33-1.63,0.16-2.45,0.33l8.82,2.78c0.65-0.49,1.31-0.82,1.8-1.47 c-0.16-1.63-0.16-3.1-0.33-4.74l-3.1-0.98C256.95,327.12,255.48,328.59,253.52,329.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M228.52,331.54c0.49,0.16,0.82,0.49,1.47,0.65v-0.16L228.52,331.54z"
}), React.createElement("path", {
  className: "st2",
  d: "M264.14,327.29c0.33-0.49,0.49-0.98,0.82-1.47c0-0.98-0.16-1.96-0.16-2.94l-3.59,0.65 c0,0.98,0.16,1.96,0.16,2.94L264.14,327.29z"
}), React.createElement("path", {
  className: "st2",
  d: "M266.59,322.55l-1.96,0.33c0,0.98,0.16,1.96,0.16,2.94C265.44,324.67,266.26,323.86,266.59,322.55z"
}), React.createElement("path", {
  className: "st2",
  d: "M230.48,328.92l-3.76,0.65c0,0.33-0.16,0.65-0.16,0.98c0.49,0.33,1.31,0.65,1.96,0.98l1.47,0.49 C230.15,330.88,230.32,329.9,230.48,328.92z"
}), React.createElement("path", {
  className: "st2",
  d: "M264.14,327.29l-2.78-0.98c0.16,1.63,0.16,3.1,0.33,4.74C262.67,330.07,263.32,328.59,264.14,327.29z"
}), React.createElement("path", {
  className: "st2",
  d: "M225.25,329.9c0,0,0.49,0.33,1.31,0.65c0-0.33,0.16-0.65,0.16-0.98L225.25,329.9z"
}), React.createElement("path", {
  className: "st2",
  d: "M299.75,264.88c4.41-1.47,8.33-3.92,11.44-7.52l-1.31-9.15c-10.46,18.79-30.39,10.78-40.36,5.23l0,0 c0,1.8,0,4.41,0.16,7.19c5.72,2.94,13.4,5.72,21.24,5.72C293.87,266.18,296.81,265.69,299.75,264.88z"
}), React.createElement("path", {
  className: "st2",
  d: "M305.47,242l2.78-0.49c-0.33-0.82-0.65-1.8-0.98-2.61h-0.16C306.62,240.21,305.96,240.86,305.47,242z"
}), React.createElement("path", {
  className: "st2",
  d: "M270.02,246.09c0,0.65-0.16,1.47-0.16,2.29l3.1-0.49C271.82,247.23,271,246.74,270.02,246.09z"
}), React.createElement("path", {
  className: "st2",
  d: "M260.05,254.58c0,0,0.49,0.33,0.65,0.49c0-0.33,0-0.82,0-1.14L260.05,254.58z"
}), React.createElement("path", {
  className: "st2",
  d: "M263.32,253.28c0-1.31,0.16-2.12,0.33-3.43l-2.94,3.92c0,0.33,0,0.82,0,1.14c0.49,0.33,1.14,0.82,2.78,1.8 C263.32,255.73,263.32,254.09,263.32,253.28z"
}), React.createElement("path", {
  className: "st2",
  d: "M315.44,241.35l-0.49-0.16c0.98,3.1,1.31,5.23,1.31,5.39L315.44,241.35z"
}), React.createElement("path", {
  className: "st2",
  d: "M269.53,253.28L269.53,253.28c-1.31-0.82-2.45-1.47-3.43-1.96c0,0.82-0.33,1.31-0.33,1.96 c0,1.31,0.16,3.43,0.16,5.06c1.14,0.65,2.12,1.31,3.59,2.12C269.69,257.69,269.53,255.07,269.53,253.28z"
}), React.createElement("path", {
  className: "st2",
  d: "M270.02,246.09c-0.82-0.49-1.96-1.14-2.61-1.63l-0.49,0.65c-0.16,1.31-0.49,2.45-0.49,3.76l3.43-0.65 C270.02,247.72,270.02,246.9,270.02,246.09z"
}), React.createElement("path", {
  className: "st2",
  d: "M311.19,257.2c1.14-1.31,2.12-2.78,3.1-4.41l-1.63-11.27c-0.82,2.45-1.8,4.57-2.78,6.37L311.19,257.2z"
}), React.createElement("path", {
  className: "st2",
  d: "M308.25,241.51l4.25-0.82v-0.33l-5.23-1.63C307.76,239.72,308.09,240.7,308.25,241.51z"
}), React.createElement("polygon", {
  className: "st2",
  points: "314.95,247.72 317.56,247.72 317.56,247.72  "
}), React.createElement("path", {
  className: "st2",
  d: "M316.09,246.41l0.33,2.61c0.98-2.12,1.96-4.25,2.78-6.54l-3.76-1.14L316.09,246.41L316.09,246.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M265.93,253.28c0-0.82,0.33-1.31,0.33-1.96c-1.47-0.98-2.45-1.63-2.45-1.63l2.78-0.49 c0.16-1.31,0.33-2.61,0.49-3.76l-3.43,4.57c0,1.14-0.33,2.12-0.33,3.43c0,0.98,0,2.45,0.16,3.59c0.65,0.49,1.8,0.98,2.78,1.47 C266.1,256.71,265.93,254.58,265.93,253.28z"
}), React.createElement("path", {
  className: "st2",
  d: "M312.5,240.7l0.49-0.16c-0.16,0.33-0.33,0.65-0.49,0.98l1.63,11.27c0.82-1.14,1.47-2.45,2.12-3.76l-0.33-2.61 c0,0-0.33-2.12-1.31-5.39l-2.29-0.65L312.5,240.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M309.88,248.05l-0.16-0.82c-0.16-1.31-0.82-3.43-1.47-5.72l-2.78,0.49c-2.45,5.55-5.39,9.48-9.64,10.78 c-7.19,2.29-16.66-1.47-22.87-4.9l-3.1,0.65c-0.16,1.63-0.33,2.94-0.33,4.74C279.49,258.83,299.59,266.84,309.88,248.05z"
}), React.createElement("path", {
  className: "st2",
  d: "M269.85,248.54l-3.43,0.65c0,0.82-0.33,1.31-0.33,2.12c0.98,0.65,1.96,1.31,3.43,1.96 C269.53,251.48,269.85,250.01,269.85,248.54z"
}), React.createElement("path", {
  className: "st2",
  d: "M309.88,247.23l0.16,0.82c0.98-1.8,1.96-3.92,2.78-6.37l-0.16-0.98l-4.25,0.82 C309.07,243.8,309.56,245.92,309.88,247.23z"
}), React.createElement("path", {
  className: "st2",
  d: "M313.15,240.7l-0.49,0.16l0.16,0.98C312.82,241.35,312.99,241.02,313.15,240.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M263.81,249.52c0,0,0.98,0.65,2.45,1.63c0-0.82,0.16-1.31,0.33-2.12L263.81,249.52z"
}), React.createElement("path", {
  className: "st2",
  d: "M315.11,192.34c0,0.49,0,0.98,0,1.47l1.47-0.33C316.09,192.99,315.6,192.66,315.11,192.34z"
}), React.createElement("path", {
  className: "st2",
  d: "M351.54,217.33c8.17-2.12,14.87-7.84,20.1-16.5l-1.47-8.5c0-0.16-0.16-0.82-0.33-1.31 c-14.54,33-41.17,19.28-53.92,9.97c0,0.33,0.16,0.98,0.16,0.98l0.98,7.52c7.19,4.57,16.66,8.82,26.63,8.82 C346.32,218.31,348.93,217.99,351.54,217.33z"
}), React.createElement("path", {
  className: "st2",
  d: "M367.56,183.51c-0.33-0.65-0.49-1.14-0.82-1.8c-0.33,0.82-0.49,1.47-0.82,2.12L367.56,183.51z"
}), React.createElement("path", {
  className: "st2",
  d: "M304.33,199.52c0.16,0.16,1.14,1.14,2.61,2.45c-0.16-1.14-0.49-2.61-0.65-4.41L304.33,199.52z"
}), React.createElement("path", {
  className: "st2",
  d: "M379.16,184.17l-2.29-0.65c0.49,1.47,0.82,2.45,1.14,3.59C378.5,185.96,378.99,185.31,379.16,184.17z"
}), React.createElement("path", {
  className: "st2",
  d: "M376.38,191.19L376.38,191.19c0.49-1.31,1.14-2.78,1.63-4.25c-0.33-0.98-0.65-2.12-1.14-3.59l-3.27-0.98 C375.73,187.43,376.38,191.19,376.38,191.19z"
}), React.createElement("path", {
  className: "st2",
  d: "M310.21,203.61c0,0-0.82-3.59-1.31-8.5l-0.16-0.16h0.16v-0.16l-2.61,2.61c0.16,1.8,0.49,3.27,0.65,4.41 c0.82,0.82,1.96,1.63,3.27,2.61L310.21,203.61z"
}), React.createElement("path", {
  className: "st2",
  d: "M370.17,192.34l1.47,8.5c0.98-1.63,1.96-2.94,2.94-4.74l-0.82-4.41c0-0.33-0.49-2.94-1.63-6.37 c-0.65,1.96-1.31,3.92-2.12,5.72C370.01,191.52,370.17,192.01,370.17,192.34z"
}), React.createElement("path", {
  className: "st2",
  d: "M366.74,181.55c0.33,0.65,0.49,1.31,0.82,1.8l3.59-0.65c-0.16-0.49-0.33-0.82-0.49-1.14l-3.43-0.98 C367.07,180.9,366.9,181.23,366.74,181.55z"
}), React.createElement("path", {
  className: "st2",
  d: "M316.25,201.97c0,0-0.16-0.65-0.16-0.98c-1.63-1.31-3.1-2.29-4.25-3.27c0.33,3.1,0.98,5.23,0.98,5.23 l0.49,3.76c1.31,0.82,2.61,1.8,3.92,2.61L316.25,201.97z"
}), React.createElement("path", {
  className: "st2",
  d: "M315.11,192.34c-0.65-0.65-1.47-1.31-1.96-1.8l-1.63,1.8c0,0.82,0,1.47,0,2.29l3.59-0.65 C315.11,193.32,315.11,192.83,315.11,192.34z"
}), React.createElement("path", {
  className: "st2",
  d: "M312.66,202.95c0,0-0.49-2.12-0.98-5.23c-1.63-1.31-2.61-2.29-2.94-2.45c0.33,4.9,1.31,8.5,1.31,8.5l0.16,0.82 c0.98,0.65,1.96,1.47,2.94,2.12L312.66,202.95z"
}), React.createElement("path", {
  className: "st2",
  d: "M370.99,182.7l2.12-0.49c-0.33,1.14-0.82,1.96-1.14,2.94c1.14,3.43,1.63,5.88,1.63,6.37l0.82,4.41 c0.65-1.47,1.31-3.27,1.96-4.9l0,0c0,0-0.82-3.92-2.78-8.66l-3.1-0.98C370.82,182.04,370.82,182.37,370.99,182.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M311.52,192.17l-2.61,2.61v0.16l2.61-0.49C311.52,193.64,311.52,192.99,311.52,192.17z"
}), React.createElement("path", {
  className: "st2",
  d: "M370.01,191.03c-0.33-1.63-1.14-4.25-2.45-7.52l-1.63,0.33c-4.25,12.09-10.13,19.44-17.48,21.4 c-10.95,2.94-24.51-5.72-31.86-11.6l-1.47,0.33c0.16,3.76,0.65,6.21,0.98,7.19C328.83,210.31,355.47,224.03,370.01,191.03z"
}), React.createElement("path", {
  className: "st2",
  d: "M308.74,194.95l0.16,0.16v-0.16H308.74z"
}), React.createElement("path", {
  className: "st2",
  d: "M315.11,193.81l-3.59,0.65c0,1.14,0.16,2.29,0.33,3.27c1.14,0.98,2.61,2.12,4.25,3.27 C315.76,199.85,315.27,197.4,315.11,193.81z"
}), React.createElement("path", {
  className: "st2",
  d: "M370.01,191.03c0.82-1.8,1.47-3.76,2.12-5.72c-0.33-0.82-0.65-1.63-0.98-2.61l-3.59,0.65 C368.86,186.78,369.68,189.39,370.01,191.03z"
}), React.createElement("path", {
  className: "st2",
  d: "M373.27,182.37l-2.12,0.49c0.33,0.82,0.82,1.8,0.98,2.61C372.46,184.33,372.78,183.51,373.27,182.37z"
}), React.createElement("path", {
  className: "st2",
  d: "M311.52,194.46l-2.61,0.49v0.16c0.33,0.33,1.31,1.14,2.94,2.45C311.68,196.75,311.52,195.6,311.52,194.46z"
}), React.createElement("path", {
  className: "st2",
  d: "M416.08,246.9c7.19-1.14,12.42-3.92,16.5-7.35l-1.8-6.37c-2.45,3.27-7.19,6.21-15.68,7.52 c-10.62,1.63-17.48,0.16-21.73-1.63c0.16,1.63,0.33,2.78,0.33,2.78l0.65,4.08c3.27,0.98,7.03,1.63,11.93,1.63 C409.22,247.72,412.49,247.39,416.08,246.9z"
}), React.createElement("path", {
  className: "st2",
  d: "M393.37,231.87c0,0.33,0,0.65,0,0.98l1.31-0.33C394.19,232.2,393.53,232.04,393.37,231.87z"
}), React.createElement("polygon", {
  className: "st2",
  points: "427.35,223.87 428.33,223.54 428.33,223.54  "
}), React.createElement("path", {
  className: "st2",
  d: "M439.44,220.76l-2.61,0.65l2.29,8.66C440.42,225.17,439.61,221.25,439.44,220.76z"
}), React.createElement("path", {
  className: "st2",
  d: "M387.49,243.15v-0.16c0,0-0.49-3.59-0.49-8.5l-2.78,1.96l0.82,4.74C385.69,241.68,386.35,242.33,387.49,243.15 z"
}), React.createElement("path", {
  className: "st2",
  d: "M437.65,233.83c0.65-1.31,1.31-2.61,1.63-3.92l-2.29-8.66l-2.61,0.65L437.65,233.83z"
}), React.createElement("polygon", {
  className: "st2",
  points: "428.17,223.7 431.76,222.72 431.76,222.72  "
}), React.createElement("path", {
  className: "st2",
  d: "M393.7,241.84c0,0-0.16-1.31-0.33-2.78c-1.63-0.65-2.78-1.47-3.76-2.12c0.16,3.1,0.49,5.23,0.49,5.55 l0.33,1.96c1.31,0.65,2.29,1.14,3.92,1.63L393.7,241.84z"
}), React.createElement("path", {
  className: "st2",
  d: "M393.37,231.87c-0.82-0.49-1.14-0.98-1.14-0.98l-2.61,1.8c0,0.49,0,0.82,0,1.14l3.76-0.98 C393.21,232.53,393.37,232.2,393.37,231.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M432.58,239.39c0.98-0.82,2.29-1.63,2.94-2.78l-2.45-8.66c-0.33,1.63-0.98,3.27-2.45,5.06L432.58,239.39z"
}), React.createElement("path", {
  className: "st2",
  d: "M433.24,228.12l2.45,8.66c0.33-0.33,0.82-0.65,1.14-0.98c0.33-0.65,0.49-1.14,0.82-1.8l-3.27-11.93l-0.98,0.16 C433.4,222.23,434.05,224.85,433.24,228.12z"
}), React.createElement("polygon", {
  className: "st2",
  points: "432.42,222.56 431.76,222.72 431.76,222.72  "
}), React.createElement("path", {
  className: "st2",
  d: "M387.49,243.15c0.82,0.49,1.96,0.82,2.94,1.31l-0.33-1.96c0-0.33-0.33-2.45-0.49-5.55 c-1.8-1.31-2.61-2.45-2.61-2.45l2.45-0.65c0-0.49,0-0.82,0-1.14l-2.61,1.8c0,4.9,0.49,8.5,0.49,8.5L387.49,243.15z"
}), React.createElement("path", {
  className: "st2",
  d: "M384.87,241.02l-0.82-4.74l-2.29,1.63C381.93,238.25,383.24,239.55,384.87,241.02z"
}), React.createElement("path", {
  className: "st2",
  d: "M415.26,240.7c8.5-1.31,13.07-4.25,15.68-7.52l-2.61-9.48l-0.98,0.16c0,0,0.49,2.61-1.14,4.9 c-1.8,2.78-5.88,4.74-11.93,5.55c-11.27,1.63-16.83-0.33-19.61-1.96l-1.31,0.33c-0.16,2.45,0,4.57,0.16,6.21 C397.78,240.86,404.48,242.17,415.26,240.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M428.17,223.54l2.61,9.48c1.31-1.63,1.96-3.43,2.45-5.06l-1.47-5.39L428.17,223.54z"
}), React.createElement("path", {
  className: "st2",
  d: "M393.21,232.85l-3.76,0.98c0,1.14,0,2.12,0,3.1c0.98,0.65,2.12,1.47,3.76,2.12 C393.21,237.43,393.21,235.3,393.21,232.85z"
}), React.createElement("path", {
  className: "st2",
  d: "M433.24,228.12c0.82-3.27,0.16-5.88,0.16-5.88l-0.98,0.33l-0.65,0.16L433.24,228.12z"
}), React.createElement("path", {
  className: "st2",
  d: "M387,234.49c0,0,0.82,1.14,2.61,2.45c0-0.98,0-1.96,0-3.1L387,234.49z"
}), React.createElement("polygon", {
  className: "st2",
  points: "561.33,158.68 561.33,158.84 561.49,158.68  "
}), React.createElement("path", {
  className: "st2",
  d: "M586,208.84l1.96,0.33c0.49,0.16,2.61,0.49,5.55,0.49c3.76,0,8.82-0.65,13.07-3.27 c-3.27-4.08-5.72-7.52-7.52-10.62c-2.12,0.98-4.74,1.47-7.03,1.31l-6.05-5.88c-8.33-10.13-11.44-16.99-12.74-21.24 c-4.25-0.49-7.84,0.16-10.95,2.61c-0.33,0.33-0.65,0.82-0.98,1.14c1.96,6.37,6.21,14.87,15.36,25.98L586,208.84z"
}), React.createElement("path", {
  className: "st2",
  d: "M559.86,166.68c2.94-1.96,6.05-3.1,9.64-3.43l-2.61-1.47l-5.39-3.1h-0.16 C560.67,159.99,559.69,162.6,559.86,166.68z"
}), React.createElement("path", {
  className: "st2",
  d: "M569.99,163.09l-3.1-1.47l2.61,1.47C569.66,163.25,569.82,163.09,569.99,163.09z"
}), React.createElement("path", {
  className: "st2",
  d: "M572.27,164.89l-2.78-1.63c-3.43,0.33-6.7,1.47-9.64,3.43c0.16,1.96,0.65,4.25,1.31,6.86 c0.33-0.33,0.65-0.82,0.98-1.14c3.1-2.45,6.86-3.1,10.95-2.61c-0.98-3.76-0.65-5.55-0.65-5.55l-2.61-1.14 c-0.16,0-0.33,0.16-0.49,0.16L572.27,164.89z"
}), React.createElement("path", {
  className: "st2",
  d: "M610.67,202.63l-9.8-8.01c-0.49,0.49-1.31,0.65-1.96,0.98c1.8,3.1,4.25,6.54,7.52,10.62 C608.05,205.24,609.52,204.1,610.67,202.63z"
}), React.createElement("path", {
  className: "st2",
  d: "M657.23,511.25l-5.06,11.93l0.33,1.8c0.16,0.82,1.63,6.37,8.66,10.46c1.96-4.41,3.76-8.17,5.55-11.27 c-0.33-0.16-0.82-0.33-0.98-0.49l2.78-6.7c5.39-9.31,9.8-14.54,13.23-17.32c0.98-3.76,1.14-7.52,0.33-10.95 c-0.33-1.31-0.98-2.12-1.47-3.27C674.55,488.22,666.38,495.08,657.23,511.25z"
}), React.createElement("path", {
  className: "st2",
  d: "M690.07,483.15c-0.16,0-0.49,0-0.82,0c0.16,0.49,0.49,0.82,0.49,1.14L690.07,483.15z"
}), React.createElement("path", {
  className: "st2",
  d: "M686.8,483.32c0.49,1.31,1.14,2.45,1.47,3.76c0.33,1.47,0.33,3.1,0.49,4.57l0.33-2.12l0.82-5.06 c-0.16-0.49-0.33-0.82-0.49-1.14C688.6,483.15,687.78,483.15,686.8,483.32z"
}), React.createElement("path", {
  className: "st2",
  d: "M688.76,492.79l0.33-3.27l-0.33,2.12C688.6,491.98,688.76,492.3,688.76,492.79z"
}), React.createElement("path", {
  className: "st2",
  d: "M685.5,487.73c-0.33-1.47-1.14-2.45-1.8-3.76c-0.98,0.33-2.12,0.82-3.27,1.31c0.49,1.14,1.14,1.96,1.47,3.27 c0.82,3.59,0.65,7.35-0.33,10.95c1.63-1.47,3.1-2.45,4.25-2.94C686.31,493.61,686.31,490.51,685.5,487.73z"
}), React.createElement("path", {
  className: "st2",
  d: "M666.71,524c-1.8,3.1-3.59,6.7-5.55,11.27c0.98,0.65,1.96,1.14,3.27,1.63c0.98-2.45,2.12-4.25,3.1-6.37 l1.8-5.06C668.01,524.98,667.36,524.49,666.71,524z"
}), React.createElement("path", {
  className: "st2",
  d: "M687.95,495.57l0.65-4.08c-0.16-1.47,0-3.1-0.49-4.57c-0.33-1.31-0.98-2.61-1.47-3.76 c-0.82,0.16-1.8,0.33-2.94,0.65c0.49,1.31,1.31,2.29,1.8,3.76c0.65,2.94,0.65,5.88,0.33,8.99c1.63-0.82,2.45-0.82,2.45-0.82 l0.33-2.94c0-0.33,0-0.82-0.16-1.14L687.95,495.57z"
}), React.createElement("path", {
  className: "st2",
  d: "M665.24,537.4l2.29-6.86c-0.98,2.12-2.12,3.92-3.1,6.37C664.75,537.07,664.91,537.23,665.24,537.4z"
}), React.createElement("polygon", {
  className: "st2",
  points: "105.17,140.22 85.4,174.69 200.25,216.84  "
}), React.createElement("polygon", {
  className: "st2",
  points: "250.09,41.21 238.98,163.09 288.48,51.5  "
}), React.createElement("polygon", {
  className: "st2",
  points: "165.94,43.33 129.84,59.83 198.62,160.97  "
}));

var SvgClapsIcon = function SvgClapsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClapsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Claps_Icon.b4d580e7.svg";
export { ForwardRef as ReactComponent };